import React, { useState } from 'react';
import { X, Shield, ChevronDown, ChevronUp } from 'lucide-react';
import { CARE_PRIVACY_V324, isCareTextReady } from '../config/careLegal';
// v3.2.8(공고 10-16 · 시행 10-23) — CAD 디자인 거래처 연결·연결 기록 3년·디자인 미리보기. 문안 docs/공고문안_처리방침v3.2.8_2026-10-16.md 글자 그대로(config/privacyV328.js 한 곳)
//   대표 10-16 "응": 공고 2026-10-16 · 시행 2026-10-23(자체 "시행 7일 전 공지" 충족). v3.2.5(11-06)·v3.2.6(11-23)보다 판 번호는 뒤지만 먼저 시행.
//   대표 10-16 "치과동의 없이 진행": 연결폴더 전송은 치과 동의 확인 없음 — 대표 위험 감수(문안 문서 §5 R-1). 업체 정보 표시도 10-23 시행(30일 자체 약속 — 대표 위험 감수, R-2).
//   시행 전: 본문은 v3.2.7 그대로 + 맨 위 「개정 공고」 상자에 바뀌는 글자 전체. 시행 뒤: 본문 v3.2.8, 상자는 "시행 중" 한 줄.
import {
    PRIVACY_V328_NOTICE_DATE, PRIVACY_V328_DATE, isPrivacyV328On, V328_OUTSOURCE, V328_INTRO_ADD, DESIGN_LINK_LOG_LINE, V328_RETENTION_WARNING,
    DESIGN_PARTNER_INFO_LINE, DESIGN_PARTNER_INFO_ROW, V328_FILE_TRANSFER_TAIL, DESIGN_PREVIEW_LINE, V328_BIZ_MEMBER_ADD, V328_GENERATED_ADD,
    V328_VERSION_DESC, V328_HISTORY_BODY, V328_NOTICE_LINE_BEFORE, V328_NOTICE_LINE_AFTER, V328_NOTICE,
} from '../config/privacyV328';
// v3.3.5(공고 10-27 · 시행 11-03) — 가입 때 치과기공사 면허번호·성명(선택)·개설등록번호·제조업 허가번호 수집(S5). 문안 docs/법무검토_가입위주_외주업체등록_S5_2026-10-27.md §2-5 글자 그대로(config/privacyV335.js 한 곳).
//   v3.2.8 전례 그대로: 시행 전 = 본문 종전 + 맨 위 「개정 공고」 상자에 바뀌는 글자 전체 / 시행 뒤 = 본문 반영 + "시행 중" 한 줄. 시행일 상수는 Register.js 입력 칸 게이트와 공유(법무 §2-2 [상]).
import {
    PRIVACY_V335_VERSION, PRIVACY_V335_NOTICE_DATE, PRIVACY_V335_DATE, isPrivacyV335On, isPrivacyV335Announced,
    V335_LAB_MEMBER_ADD, V335_MFR_ROW, V335_COLLECT_METHOD_LINE, V335_PURPOSE_ITEMS, V335_RETENTION_LINE, V335_ACCESS_LINE,
    V335_HISTORY_BODY, V335_VERSION_DESC, V335_NOTICE_LINE_BEFORE, V335_NOTICE_LINE_AFTER, V335_NOTICE,
} from '../config/privacyV335';

// v3.2.5 — 덴클 케어(분리 환자앱) 추가분 + §4-4ⓑ 진료 후 질문·재내원 안내 2항목 (2026-10-04 계획_환자앱1차_통합 W6 정본 §4 → 2026-10-06 정본 질문로드맵 §5).
//   문안은 config/careLegal.js CARE_PRIVACY_V324 한 곳(상수 이름은 그대로, 판은 version 필드 'v3.2.5'). 공고 2026-10-06 · 시행 2026-11-06(업무약관 v7.0 과 같은 날, 대표 10-06).
//   TODO·자리표시가 남아 있으면 V324=null → 아래 추가분 자리는 전부 그리지 않는다(현행 v3.2.3 그대로). 시행 전에는 버전 줄에 "시행 예정".
const V324 = isCareTextReady(CARE_PRIVACY_V324) ? CARE_PRIVACY_V324 : null;
const V324_EFFECTIVE_MS = V324 ? Date.parse(V324.effectiveAtIso) : NaN;

// v3.2.1 공고·시행일 — 데스크 접수 켜는 날(2026-10-04, 대표 "바로진행")
const PRIVACY_V321_DATE = '2026년 10월 4일';
// v3.2.2 공고일·시행일 — 데스크 직접 입력분 수탁 처리 추가(정본 §8-3-2). 2026-10-04 대표 결정: 즉시안(공고일 = 시행일, 자체 "7일 전 공지" 약속과의 차이는 대표 위험 감수·변호사 M-5).
//   시행일은 서버 functions/lib/desk-reception.js DESK_ADD_EFFECTIVE_FROM(직접 추가 개시일)과 같은 날이어야 한다.
const PRIVACY_V322_NOTICE_DATE = '2026년 10월 4일';
const PRIVACY_V322_DATE = '2026년 10월 4일';
// v3.2.3 공고일·시행일 — 결제 수탁자 토스페이먼츠 추가·문의 전화 변경(계획 docs/계획_요금변경_2026-10-04.md §4-5).
//   공고 2026-10-04·시행 2026-10-11(대표 결정 10-04). 수탁자 추가는 자체 "7일 전 공지" 약속(섹션 11) 대상 — 토스 처리 개시(카드 등록 화면 노출)는 시행일 이후.
const PRIVACY_V323_NOTICE_DATE = '2026년 10월 4일';
const PRIVACY_V323_DATE = '2026년 10월 11일';
// (v3.2.3 「시행 예정」 분기는 10-11 시행 뒤 v3.2.7 버전 줄 교체로 삭제 — 10-13)
// v3.2.7 공고·시행일 — 기공소 간 외주(CAD 디자인·제작) 기록의 수탁 처리 절 추가(정본 docs/정본_처리방침_외주기록_2026-10-13.md).
//   2026-10-13 대표 결정 "전부 지금 바로 진행해도 돼, 아무도 안 써": 즉시안(공고일 = 시행일). 자체 "7일 전 공지" 약속과의 차이는 대표 위험 감수·변호사 E8.
//   판 번호는 v3.2.5(11-06 시행 예정)·v3.2.6(11-23 시행 예정)보다 뒤지만 먼저 시행된다. 이 절은 V324(careLegal) 조건과 무관하게 항상 그린다.
const PRIVACY_V327_DATE = '2026년 10월 13일';

// [치과 데스크 접수 기록의 처리] — 정본 docs/정본_데스크접수_동의·방침_2026-10-04.md §4-1 + §7-4-1(처리 항목 괄호·만 14세 미만 줄 교체) + §8-3-1(v3.2.2 데스크 직접 입력 — 마지막 항목)
const DESK_RECEPTION_ITEMS = [
    '처리 항목: 다녀간 적 있는 환자는 이름과 오신 이유(검진·치료·상담·기타 중 선택), 처음 온 환자는 이름·생년월일·성별·휴대폰 번호·주소·오신 이유. 그 밖에 접수 일시, 동의 기록(동의 문안의 판·일시·작성자 구분(본인 또는 법정대리인)·만 14세 이상 확인 여부·접속 브라우저 정보·IP 주소를 변환한 값, 법정대리인이 작성한 경우 법정대리인의 이름과 환자와의 관계)을 함께 보관합니다.',
    '처리 목적: 대기 순서 안내, 해당 의료기관의 지난 접수 기록 조회, 같은 날 같은 이름으로 작성된 보철물 의뢰 기록과의 연결.',
    '보유 기간: 접수일부터 2년(관계 법령에 따른 기간이 아니라 의료기관과의 위탁 약정에 따른 기간입니다). 기간이 지나면 자동으로 삭제하며, 연결된 의뢰서에서도 접수 연결 정보를 지웁니다. 환자가 의료기관에 삭제를 요청하면 기간 전이라도 삭제합니다.',
    '안전 조치: 접수 기록은 해당 의료기관의 대표·직원 계정만 볼 수 있으며, 처음 온 환자의 접수 카드를 열람하면 접속기록을 남깁니다.',
    '재위탁: 데이터 저장과 서버 기능은 위 표의 Google LLC(Firebase)가 처리하며, 국외(미국 등)에서 처리될 수 있습니다.',
    '회사는 이 정보를 위탁 목적 밖(광고, 다른 의료기관과의 공유 등)으로 이용하지 않습니다.',
    '접수 기록은 「의료법」에 따른 진료기록부가 아닙니다. 진료에 관한 기록은 의료기관이 따로 작성·보존합니다.',
    '만 14세 미만 환자의 접수는 법정대리인(부모 또는 후견인)이 대신 작성하고 동의합니다. 이때 법정대리인의 이름과 환자와의 관계를 동의 기록으로 함께 보관하며, 접수 기록과 같은 때(접수일부터 2년) 삭제합니다. 아동의 접수 기록도 위 목적 밖으로 이용하지 않으며, 법정대리인은 해당 의료기관에 아동 개인정보의 열람·정정·삭제·처리정지를 요구할 수 있습니다.',
    '접수 기록의 열람·정정·삭제·처리정지 요구는 해당 의료기관에 하시면 됩니다. 회사가 요구를 받으면 지체 없이 해당 의료기관에 전달합니다.',
    // v3.2.2 — 정본 §8-3-1 (데스크 직접 입력, 목록 마지막 항목)
    '데스크 직접 입력(v3.2.2부터): 의료기관의 대표·직원이 데스크에서 직접 입력한 대기 환자의 이름과 오신 이유(선택)도 회사가 해당 의료기관의 위탁을 받아 처리합니다. 목적은 그날 대기 순서 안내(의료기관이 의뢰서를 작성할 때 이름을 불러오는 것 포함)뿐이고, 보유 기간은 입력한 날까지입니다(자정에 마감하고 마감 뒤 자동으로 삭제). 지난 접수 기록 조회·이름 검색·의뢰서 연결에는 쓰지 않으며, 입력·삭제한 계정은 접속기록으로 남깁니다(접속기록에 환자 이름은 남기지 않습니다).',
];

// [기공소 간 외주(CAD 디자인·제작) 기록의 처리] — 정본 docs/정본_처리방침_외주기록_2026-10-13.md §1-4 (v3.2.7)
//   v3.2.8(10-23 시행): 아래 OUTSOURCE_RECORD_ITEMS_V328 — 재위탁 근거 문단 교체(연결폴더 전송은 치과 동의 확인 없음, 대표 10-16)·연결형 항목 추가.
//   재위탁 동의 확인 항목: 10-13 대표 "가"로 회사당 처음 1회 동의로 바뀜(정본은 케이스별 체크로 작성됨). 또 정본은 두 흐름 모두 체크로 적었으나 제작 외주(outsourceMf)에는 체크가 아직 없어(정본 P1-1) CAD 는 「의뢰할 때마다」, 제작 외주는 「기능을 열 때부터」로 적었다 — 제작 외주 체크(mf-attest-1.0)는 스위치를 켜기 전 구현.
const OUTSOURCE_RECORD_ITEMS = [
    '처리 항목: 환자 이름, 케이스 번호, 치식(치아 번호)·보철 종류·재료 등 보철 정보, 납기 희망일, 첨부 파일의 이름과 개수(파일 이름에 들어 있는 환자 이름은 가려서 저장합니다), 진행 상태와 그 일시, 받는 곳이 기록을 연 기록과 파일을 내려받은 기록(누가·언제), 거절·취소 사유, 보내는 기공소의 재위탁 동의 확인 기록(아래 참고).',
    '처리 목적: 외주 작업의 전달과 진행 확인, 받는 곳이 다른 환자와 혼동하지 않게 하는 것, 보내는 기공소와 받는 곳 사이의 정산.',
    '재위탁 동의 확인: 보내는 기공소의 대표는 외주를 처음 이용할 때 한 번, "앞으로 보내는 케이스는 그 보철을 맡긴 치과로부터 다른 곳에 맡겨도 된다는 동의를 받은 것으로 합니다"라는 항목에 동의해야 의뢰를 보낼 수 있습니다(CAD 디자인은 지금부터, 제작 외주는 회사가 이 기능을 연 때부터). 회사는 동의한 계정·일시·동의 문구의 판을 보관하고, 각 의뢰 기록에 그 동의의 판과 일시를 함께 남깁니다. 이 동의는 환자 본인의 동의가 아니라 치과의 동의입니다.',   // 10-13 대표 "가" — 케이스별 체크 → 회사당 1회 동의
    '받는 곳이 환자 이름을 볼 수 있는 기간: CAD 디자인은 받는 곳이 의뢰를 수락한 때부터 완료 후 30일까지입니다(완료 처리가 되지 않으면 결과 파일을 보낸 날부터 30일까지). 수락 전에는 가운데를 가린 이름(예: 김○수)만 보입니다. 제작 외주는 의뢰를 받은 때부터, 받는 곳이 파일을 처음 내려받아 「제작 중」이 된 날부터 30일까지입니다. 거절·취소된 의뢰는 그때부터 받는 곳이 환자 이름을 볼 수 없습니다. 기간이 지나면 받는 곳에는 케이스 번호만 보입니다.',
    'CNC 가공: CNC 가공을 맡기는 경우 받는 곳에는 환자 이름을 보내지 않고 케이스 번호만 보냅니다(보내는 기공소 화면에는 환자 이름이 남습니다).',
    '보유 기간: 마지막으로 상태가 바뀐 날(보냄·확인·수락·제작 중·전달·완료·거절·취소가 있은 날을 말하며, 파일을 다시 올리거나 다시 내려받거나 메모를 고친 것은 포함하지 않습니다)부터 2년입니다. 이 기간은 관계 법령에 따른 기간이 아니라 회원과의 위탁 약정에 따른 기간입니다. 기간이 지나면 기록을 자동으로 삭제하고, 삭제한 사실(건수·일시)을 남깁니다.',
    '환자 이름을 먼저 지우는 경우: ① 거절·취소된 의뢰는 거절·취소된 날부터 30일이 지나면 환자 이름을 지웁니다(나머지 이력과 사유는 위 보유 기간 동안 보관). ② 제작 외주에서 받는 곳이 30일 동안 열어 보지 않은 의뢰는 회사가 취소 처리하며, 그 뒤 ①과 같이 처리합니다. CAD 디자인에서 받는 곳이 30일 동안 수락하지 않은 의뢰는 의뢰일부터 30일이 지나면 환자 이름을 지웁니다. ③ 보내는 기공소가 탈퇴하면 탈퇴일부터 7일이 지난 뒤 환자 이름을 지우며, 그 전에 반환을 요청할 수 있습니다. ④ 환자가 치과나 치과기공소에 삭제를 요구하면 보내는 기공소의 대표(또는 회사)가 기간 전이라도 환자 이름을 지웁니다. 이때 진행 상태와 이력은 남습니다.',
    '파일: 첨부 파일(구강 스캔·CAD·STL)은 회사 서버를 거쳐 전달만 하며 보관하지 않습니다. 받는 곳이 처음 내려받은 뒤 24시간 안에, 내려받지 않더라도 올린 날부터 늦어도 7일 안에 자동 삭제하고, 거절·취소되면 바로 삭제합니다. 전송 구간은 암호화합니다.',
    '정산 서류: 외주 거래명세서에는 환자 이름을 넣지 않고 케이스 번호·종류·수량·금액만 적습니다.',
    '적용 시점: CAD 디자인은 회사가 환자 이름을 그대로 저장하기 시작한 뒤에 만든 의뢰부터 위 내용이 적용되며, 그 전에 만든 의뢰에는 가운데를 가린 이름만 저장되어 있습니다. 제작 외주는 회사가 이 기능을 연 때부터 적용됩니다. 이 절을 적용하기 전에 만들어진 외주 기록에도 같은 보유 기간(마지막 상태 변경일부터 2년)을 적용합니다.',
    '재위탁: 데이터 저장과 서버 기능은 위 표의 Google LLC(Firebase)가 처리하며, 국외(미국 등)에서 처리될 수 있습니다. 회사는 이 기록을 위탁 목적 밖(광고, 다른 회원과의 공유 등)으로 이용하지 않습니다.',
    '외주 기록은 「의료기사 등에 관한 법률」에 따라 치과의사와 치과기공소가 각자 2년 보존하는 치과기공물제작의뢰서가 아니며, 그 보존 의무를 대신하지 않습니다.',
];

// v3.2.8 외주 기록 절 (문안 §1-2) — 순서는 v3.2.7 과 같고, ★ 줄은 config/privacyV328.js, 표시 없는 줄은 위 v3.2.7 배열 글자 그대로
const OUTSOURCE_RECORD_ITEMS_V328 = [
    V328_OUTSOURCE.items,          // 1 ★
    V328_OUTSOURCE.purpose,        // 2 ★
    V328_OUTSOURCE.basis,          // 3 ★
    V328_OUTSOURCE.linkAuto,       // 4 ★ 신설
    V328_OUTSOURCE.viewPeriod,     // 5 ★
    V328_OUTSOURCE.recvFolder,     // 6 ★ 신설
    OUTSOURCE_RECORD_ITEMS[4],     // 7 CNC 가공
    OUTSOURCE_RECORD_ITEMS[5],     // 8 보유 기간
    V328_OUTSOURCE.earlyDelete,    // 9 ★
    V328_OUTSOURCE.files,          // 10 ★
    OUTSOURCE_RECORD_ITEMS[8],     // 11 정산 서류
    V328_OUTSOURCE.applyFrom,      // 12 ★
    OUTSOURCE_RECORD_ITEMS[10],    // 13 재위탁(Firebase)
    OUTSOURCE_RECORD_ITEMS[11],    // 14 치과기공물제작의뢰서 아님
];
// 개정 공고 상자의 「바뀌는 문장 전문」 — ★ 줄만(문안 §2-4 구현 지시)
const V328_CHANGED_OUTSOURCE = [0, 1, 2, 3, 4, 5, 8, 9, 11].map(i => OUTSOURCE_RECORD_ITEMS_V328[i]);

// [치과 지그 결과의 처리] — 법무 docs/지그웹a_처리방침동의_2026-10.md §1-3 (지그 웹 a안: 클라우드 2주 보관).
//   ⚠️ 코드 준비만. 시행일·판 번호는 법적보안이 고지 경과(변호사 V2: 자체 7일 vs 30일 — §2-3) 뒤 확정한다.
//   PRIVACY_JIG_EFFECTIVE_ISO 가 null 이면 절 전체·동반 수정이 전부 숨겨진다(fail-closed, 서버 jigWeb 플래그 ON 과 별개).
//   켜는 순서(계약 §8·법무 §0): ① 이 ISO 에 시행일 기입 + 변경이력 반영 → ② 고지(공고 상자) → ③ 서버 jigWeb 배포 → ④ config/features.jigWeb=true.
const PRIVACY_JIG_EFFECTIVE_ISO = '2026-10-21';   // 시행일 = 공고일(당일 시행, 대표 지시 2026-10-21). 시행일 00:00 KST 전이면 fail-closed로 지그 절 비노출.
const PRIVACY_JIG_VERSION = 'v3.2.9';
const PRIVACY_JIG_DATE = '2026년 10월 21일';     // 시행일
const PRIVACY_JIG_VERSION_DESC = '치과 지그 결과의 처리 절 추가(클라우드 2주 보관)';   // 법무 §1-5
// [법적보안 2026-10-24] v3.3.3 — 지그·3D 모델 결과의 웹 보관 14일→7일(서버 jig-queue.js·model-queue.js STORE_RETAIN_DAYS=7, 대표 10-23·10-24 승인),
//   3D 모델 결과·결과 사진(지그·모델·결합 PNG, 모델 바닥 음각 환자 이름이 형상으로 보임) 항목 추가. 문안 초안 — 변호사 최종 검토 전. 배포는 대표 확인 뒤.
const PRIVACY_JIG7_VERSION = 'v3.3.3';
const PRIVACY_JIG7_DATE = '2026년 10월 24일';
const PRIVACY_JIG7_VERSION_DESC = '치과 지그 결과의 처리 절 개정 — 보관 기간 7일로 단축, 3D 모델 결과·결과 사진 항목 추가';
const isPrivacyJigOn = !!PRIVACY_JIG_EFFECTIVE_ISO
    && Date.now() >= Date.parse(PRIVACY_JIG_EFFECTIVE_ISO + 'T00:00:00+09:00');
// 📢 지그 개정 공고(고지) — 공고일 2026-10-21 · 시행 2026-10-28. 공고 상자는 공고일부터 노출(시행과 별개 — 법무 §2·§4).
//   게시 끝 2026-11-04(법무 §2 권고: 시행 후 최소 1주). 기간 중 내리지 않는다.
const PRIVACY_JIG_NOTICE_ISO = '2026-10-21';
const PRIVACY_JIG_NOTICE_DATE = '2026년 10월 21일';
const PRIVACY_JIG_NOTICE_END_ISO = '2026-11-04';
const isPrivacyJigNoticePeriod = Date.now() >= Date.parse(PRIVACY_JIG_NOTICE_ISO + 'T00:00:00+09:00')
    && Date.now() < Date.parse(PRIVACY_JIG_NOTICE_END_ISO + 'T00:00:00+09:00');
// 공고 상자 문안 — 법무 docs/지그웹a_처리방침개정_고지준비_2026-10-21.md §2 글자 그대로
const PRIVACY_JIG_NOTICE = {
    title: '개인정보 처리방침 개정 공고 (v3.2.9)',
    dates: '공고일: 2026년 10월 21일 · 시행일: 2026년 10월 28일',
    reason: '치과기공소가 쓰는 지그(치과 작업 보조 틀) 자동 생성 기능의 결과 파일을 기공소가 덴클 웹에서 내려받을 수 있도록, 그 결과 파일을 회사 서버(클라우드)에 일정 기간 보관하는 처리를 실제와 맞게 적기 위해 개정합니다.',
    mains: [
        '1. 지그 자동 생성 결과 파일(STL 등 3D 모델)에는 환자 이름·치식(치아 번호)·치과 이름이 음각(새김)으로 들어갑니다. 이 결과 파일을 생성일부터 2주(14일) 동안 덴클 서버에 보관하고, 그 기공소가 덴클 웹에서 내려받을 수 있게 합니다.',
        '2. 2주가 지나면 결과 파일과 그 안의 환자 정보를 자동으로 삭제하고, 삭제한 사실(건수·일시)을 남깁니다. 환자가 치과나 기공소에 삭제를 요구하면 2주 전이라도 지웁니다.',
        '3. 그 결과를 만든 기공소 본인 계정(대표·직원)만 볼 수 있고, 다른 회원·다른 기공소에는 보이지 않습니다. 전송 구간은 암호화하고, 열람·내려받기 기록(누가·언제)을 남깁니다(이 기록에 환자 이름은 남기지 않습니다).',
        '4. 지금까지 "첨부 파일은 전달만 하고 보관하지 않는다"고 적어 둔 원칙은 스캔·CAD 같은 전달용 파일에만 해당하며, 지그 결과 파일은 그 예외로 2주 보관함을 분명히 적습니다.',
        '5. 데이터 저장·서버 기능은 Google LLC(Firebase)가 처리하며 국외(미국 등)에서 처리될 수 있습니다. 회사는 이 결과 파일을 광고·다른 회원과의 공유 등 위탁 목적 밖으로 쓰지 않습니다.',
        '6. 지그 결과는 「의료법」 진료기록부가 아니고, 「의료기사 등에 관한 법률」의 치과기공물제작의뢰서도 아닙니다.',
    ],
    contact: '문의: 개인정보 보호책임자 010-2972-3733 · dentcluster@gmail.com',
    lineBefore: '개인정보 처리방침 v3.2.9 개정을 2026년 10월 21일에 공고했습니다. 시행일 2026년 10월 28일까지는 현행 방침이 적용됩니다.',
    lineAfter: '개인정보 처리방침 v3.2.9가 2026년 10월 28일부터 시행 중입니다(2026년 10월 21일 공고). ※ 2026년 10월 24일 개정(v3.3.3)으로 지그·3D 모델 결과의 보관 기간이 생성일부터 7일로 줄었고, 3D 모델 결과와 결과 사진이 처리 항목에 추가되었습니다.',
};
// [법적보안 2026-10-24] 아래 항목은 v3.3.3 개정 문안 초안(보관 7일·3D 모델 결과·결과 사진). 종전(v3.2.9, 2주) 문구는 변경 이력 줄에 남긴다.
const JIG_RESULT_ITEMS = [
    '처리 항목: ① 지그 결과 파일(STL 등 3D 모델), ② 3D 모델 결과 파일(위·아래 모델과 교합기. STL 등 3D 모델), ③ 결과 사진(작업자가 지그·3D 모델을 화면에 그려 저장한 PNG 이미지. 지그 사진·모델 사진·지그와 모델을 함께 담은 사진), 이들 파일에 음각(새김)으로 들어가는 환자 이름, 치식(치아 번호), 해당 치과의 이름(업체명)(결과 사진에는 모델 바닥에 새긴 환자 이름이 형상으로 보일 수 있습니다), 생성 일시, 기공소가 결과를 열람·내려받은 기록(누가·언제).',
    '처리 목적: 기공소가 자기가 의뢰받은 케이스의 지그·3D 모델 결과를 내려받아 제작에 쓰도록 전달·조회하게 하고, 결과 사진으로 내려받기 전에 결과 모양을 확인하게 하는 것.',
    '보유 기간: 생성일부터 7일. 기간이 지나면 결과 파일·결과 사진과 그에 딸린 환자 정보(음각 이름·치식·치과명 포함)를 자동으로 삭제하고, 삭제 사실(건수·일시)을 남깁니다. 이 기간은 관계 법령에 따른 기간이 아니라 회원과의 위탁 약정에 따른 기간입니다. 환자가 치과나 기공소에 삭제를 요구하면 기간 전이라도 삭제합니다. (2026년 10월 24일 개정 전에는 생성일부터 2주(14일)였습니다.)',
    '볼 수 있는 사람: 그 결과를 생성한 기공소 회원(대표·직원 계정)만 열람·내려받을 수 있습니다. 다른 회원·다른 기공소·받는 곳에는 보이지 않습니다.',
    '안전 조치: 결과 파일은 전송 구간을 암호화하여 주고받고, 그 기공소 본인 계정만 접근하도록 통제하며, 열람·내려받기 기록(누가·언제)을 남깁니다. 이 기록에는 환자 이름을 남기지 않습니다.',
    '재위탁: 데이터 저장과 서버 기능은 위 표의 Google LLC(Firebase)가 처리하며, 국외(미국 등)에서 처리될 수 있습니다. 회사는 이 결과 파일을 위탁 목적 밖(광고, 다른 회원과의 공유 등)으로 이용하지 않습니다.',
    '지그 결과는 「의료법」에 따른 진료기록부가 아니며, 「의료기사 등에 관한 법률」에 따라 치과의사·치과기공소가 각자 보존하는 치과기공물제작의뢰서도 아닙니다. 그 보존 의무를 대신하지 않습니다.',
];
// 기공소 첫 이용 1회 체크 동의 (법무 §2-2, 외주 재위탁 동의 방식 준용) — 실제 수집(Register/첫 이용) 연결은 켜는 시점.
//   지금은 문안·판만 준비한다. export 로 Register 등에서 불러쓸 자리를 비워 둔다.
export const JIG_CONSENT_VERSION = 'jig-1.0';
// [법적보안 2026-10-24] 문안만 7일·3D 모델 결과·결과 사진으로 고침. 동의 판(JIG_CONSENT_VERSION)은 그대로 둠 — 보관 기간이 짧아지는 변경이라 재동의 필요 여부는 대표·변호사 확인 뒤 결정(판을 올리면 기존 회원이 다시 동의해야 함).
export const JIG_CONSENT_TEXT = '지그 자동 생성 기능을 이용하면, 그 결과 파일(지그·3D 모델 결과와 결과 사진. 환자 이름·치식·치과명이 들어갈 수 있음)이 생성일부터 7일 동안 덴클 서버(클라우드)에 보관되며 7일 뒤 자동 삭제된다는 점에 동의합니다. 이 결과에 담긴 환자 정보에 대한 환자 본인 동의 확보 책임은 해당 치과에 있습니다.';

// ───────────────────────────────────────────────────────────────────────────
// [완성 디자인 산출물의 처리] — 법무 docs/완성디자인STL_A_처리방침개정_고지준비_2026-10-21.md §1~§3.
//   재택(home)·외주(outsource)·지그(jig) 공통 완성 STL 의 클라우드 2주 보관(A).
//   ⚠️ 코드 준비만. 시행일 = 공고일(2026-10-21, 당일 시행, 대표 지시 2026-10-21).
//   PRIVACY_DESIGN_EFFECTIVE_ISO 가 null 이면 절 전체·동반 수정이 전부 숨겨진다(fail-closed, 서버 designResults 플래그와 별개).
//   ⚠️ 서버 functions/lib/design-results.js:47 PRIVACY_DESIGN_EFFECTIVE_ISO 와 같은 날짜 문자열로 수동 동기화해야 한다(둘 중 하나만 다르면 방침–실제 불일치).
// ───────────────────────────────────────────────────────────────────────────
const PRIVACY_DESIGN_EFFECTIVE_ISO = '2026-10-21';   // 시행일 = 공고일(당일 시행, 대표 지시 2026-10-21). 00:00 KST 전이면 fail-closed 로 design 절 비노출.
const PRIVACY_DESIGN_VERSION = 'v3.3.0';
const PRIVACY_DESIGN_DATE = '2026년 10월 21일';     // 시행일(사람이 읽는 표기)
const PRIVACY_DESIGN_VERSION_DESC = '완성 디자인 산출물(재택·외주·지그)의 클라우드 2주 보관 처리 추가';   // 법무 §1-0
// [법적보안 2026-10-24] v3.3.4 — 완성 디자인(재택·외주 완성 STL) 보관 문구 정정. 종전 「내려받으면 그 뒤 삭제」는 서버 함수(confirmDesignDownload)만 있고 웹·에이전트 어디서도 호출하지 않아
//   실제로는 생성일부터 14일 보관으로 동작해 왔음(10-24 대조). 대표 결정(10-24 밤): 14일 유지·보관 기간 안 재다운로드 허용(fn design-results.js:263~295 받음 기록만, 삭제 안 함).
//   공개 정확성 정정(보관 기간 사실상 동일) — 즉시 시행. 문안 초안 — 변호사 최종 검토 전. ※ v3.3.4 번호는 KISPG 행(취소)에 쓰려던 번호를 이 건에 사용.
const PRIVACY_DESIGN14_VERSION = 'v3.3.4';
const PRIVACY_DESIGN14_DATE = '2026년 10월 24일';
const PRIVACY_DESIGN14_VERSION_DESC = '완성 디자인 산출물의 처리 절 개정 — 보유 기간을 생성일부터 14일 보관으로 정리(내려받아도 기간 안에는 삭제하지 않고 다시 내려받기 가능), 내려받기 기록(누가·언제) 명시';
export const isPrivacyDesignOn = !!PRIVACY_DESIGN_EFFECTIVE_ISO
    && Date.now() >= Date.parse(PRIVACY_DESIGN_EFFECTIVE_ISO + 'T00:00:00+09:00');
// 📢 완성 디자인 개정 공고(고지) — 공고일 2026-10-21 · 시행 2026-10-21(당일). 공고 상자는 공고일부터 노출. 게시 끝 2026-11-04(법무 §2).
const PRIVACY_DESIGN_NOTICE_ISO = '2026-10-21';
const PRIVACY_DESIGN_NOTICE_DATE = '2026년 10월 21일';
const PRIVACY_DESIGN_NOTICE_END_ISO = '2026-11-04';
const isPrivacyDesignNoticePeriod = Date.now() >= Date.parse(PRIVACY_DESIGN_NOTICE_ISO + 'T00:00:00+09:00')
    && Date.now() < Date.parse(PRIVACY_DESIGN_NOTICE_END_ISO + 'T00:00:00+09:00');
// 공고 상자 문안 — 법무 §2 (삭제 문구는 §6 정합: 환자 요구 즉시삭제로 단정하지 않고 "요청에 따라 처리" 수준)
const PRIVACY_DESIGN_NOTICE = {
    title: '개인정보 처리방침 개정 공고 (v3.3.0)',
    dates: '공고일: 2026년 10월 21일 · 시행일: 2026년 10월 21일',
    reason: '재택 디자이너·CAD 디자인 외주·지그에서 만든 완성 디자인 파일(STL)을, 그 결과를 만든 기공소가 덴클 웹에서 내려받을 수 있도록, 그 완성 파일을 회사 서버(클라우드)에 일정 기간 보관하는 처리를 실제와 맞게 적기 위해 개정합니다. (지금까지의 "파일을 PC끼리 왕복"하던 방식을 "완성본만 웹에서 내려받기"로 바꾸는 데 따른 것입니다.)',
    mains: [
        '1. 재택·외주·지그에서 만든 완성 디자인 파일(STL 등 3D 모델)에는 환자 이름·치식(치아 번호)·치과 이름이 음각(새김)으로 들어갑니다. 이 완성 파일을 덴클 서버에 보관하고, 그 완성본을 만든 기공소가 덴클 웹에서 내려받을 수 있게 합니다.',
        '2. 보관 기간은 생성일부터 2주(14일)이며, 14일이 지나면 자동으로 삭제합니다. 보관 기간 안에는 그 완성본을 만든 기공소가 여러 번 내려받을 수 있고(다른 PC에서도), 내려받기 기록(누가·언제)을 남깁니다. 삭제한 사실(건수·일시)을 남깁니다. 환자가 치과나 기공소에 삭제를 요구하면 그 요청에 따라 2주 전이라도 삭제할 수 있습니다. (※ 공고 당시 「내려받으면 그 뒤 삭제」로 적었던 부분은 2026년 10월 24일 개정(v3.3.4)으로 위와 같이 정정했습니다.)',
        '3. 그 완성본을 만든 기공소 본인 계정(대표·직원)만 볼 수 있고, 다른 회원·다른 기공소에는 보이지 않습니다. 전송 구간은 암호화하고, 열람·내려받기 기록(누가·언제)을 남깁니다(이 기록에 환자 이름은 남기지 않습니다).',
        '4. 완성 파일은 자동으로 보관되며, 기공소는 설정에서 자동 보관을 끌 수 있습니다(끄면 완성본은 서버에 올라가지 않고 작업한 PC에만 남습니다).',
        '5. 지금까지 "첨부 파일은 전달만 하고 보관하지 않는다"고 적어 둔 원칙은 스캔·CAD 중간파일 같은 전달용 파일에만 해당하며, 완성 디자인 파일은 그 예외로 2주 보관함을 분명히 적습니다. (원본 자료·중간 작업파일은 종전대로 작업한 PC에 있고 서버에 보관하지 않습니다.)',
        '6. 데이터 저장·서버 기능은 Google LLC(Firebase)가 처리하며 국외(미국 등)에서 처리될 수 있습니다. 회사는 이 완성 파일을 광고·다른 회원과의 공유 등 위탁 목적 밖으로 쓰지 않습니다.',
        '7. 완성 디자인 결과는 「의료법」 진료기록부가 아니고, 「의료기사 등에 관한 법률」의 치과기공물제작의뢰서도 아닙니다.',
    ],
    contact: '문의: 개인정보 보호책임자 010-2972-3733 · dentcluster@gmail.com',
    lineBefore: '개인정보 처리방침 v3.3.0 개정을 2026년 10월 21일에 공고했습니다. 시행일 2026년 10월 21일까지는 현행 방침이 적용됩니다.',
    lineAfter: '개인정보 처리방침 v3.3.0이 2026년 10월 21일부터 시행 중입니다(2026년 10월 21일 공고). ※ 2026년 10월 24일 개정(v3.3.4)으로 완성 디자인 파일의 보관 기간이 「내려받으면 그 뒤 삭제」에서 「생성일부터 14일 보관(보관 기간 안에는 다시 내려받기 가능)」으로 정리되었습니다.',
};
// 처리방침 [완성 디자인 산출물의 처리] 절 항목 — 법무 §1-1 (삭제 문구는 §6 정합 반영)
const DESIGN_RESULT_ITEMS = [
    '처리 항목: 완성 디자인 파일(STL 등 3D 모델. 지그·3D 모델 결과와 결과 사진은 위 [치과 지그 결과의 처리] 절에 따르며 보관 기간은 생성일부터 7일입니다), 그 파일에 음각(새김)으로 들어가는 환자 이름, 치식(치아 번호), 해당 치과의 이름(업체명), 생성 일시, 기공소가 결과를 열람·내려받은 기록(누가·언제).',
    '처리 목적: 기공소가 자기가 의뢰받은 케이스의 완성 디자인 결과를 내려받아 제작에 쓰도록 전달·조회하게 하는 것.',
    '보유 기간: 생성일부터 2주(14일). 14일이 지나면 결과 파일과 그에 딸린 환자 정보(음각 이름·치식·치과명 포함)를 자동으로 삭제하며, 삭제 사실(건수·일시)을 남깁니다. 보관 기간 안에는 그 결과를 생성한 기공소 회원이 여러 번 내려받을 수 있고(내려받아도 기간 안에는 삭제하지 않습니다), 내려받기 기록(누가·언제)을 남깁니다. 이 기간은 관계 법령에 따른 기간이 아니라 회원과의 위탁 약정에 따른 기간입니다. 환자가 치과나 기공소에 삭제를 요구하면 그 요청에 따라 기간 전이라도 삭제할 수 있습니다. (2026년 10월 24일 개정 전 문안은 「내려받으면 그 뒤 삭제하고, 내려받지 않더라도 생성일부터 2주」였습니다.)',
    '볼 수 있는 사람: 그 결과를 생성한 기공소 회원(대표·직원 계정)만 열람·내려받을 수 있습니다. 다른 회원·다른 기공소·받는 곳에는 보이지 않습니다.',
    '안전 조치: 결과 파일은 전송 구간을 암호화하여 주고받고, 그 기공소 본인 계정만 접근하도록 통제하며, 열람·내려받기 기록(누가·언제)을 남깁니다. 이 기록에는 환자 이름을 남기지 않습니다.',
    '올리는 방식: 완성 결과가 만들어지면 자동으로 보관됩니다. 기공소는 설정에서 자동 보관을 끌 수 있으며(opt-out), 끄면 완성 결과는 회사 서버에 보관되지 않고 작업한 PC에만 남습니다.',
    '재위탁: 데이터 저장과 서버 기능은 위 표의 Google LLC(Firebase)가 처리하며, 국외(미국 등)에서 처리될 수 있습니다. 회사는 이 결과 파일을 위탁 목적 밖(광고, 다른 회원과의 공유 등)으로 이용하지 않습니다.',
    '책임: 완성 결과에 담긴 환자 개인정보의 개인정보처리자 책임은 그 환자의 진료·기공을 담당하고 회사에 외주를 맡긴 회원(치과 또는 치과기공소)에게 있으며, 회사는 수탁자로서 「개인정보 보호법」 제26조에 따른 안전조치 의무를 집니다.',
    '완성 디자인 결과는 「의료법」에 따른 진료기록부가 아니며, 「의료기사 등에 관한 법률」에 따라 치과의사·치과기공소가 각자 보존하는 치과기공물제작의뢰서도 아닙니다. 그 보존 의무를 대신하지 않습니다.',
];
// 완성 디자인 동의(DESIGN_CONSENT) — /home-work·/design-outsource 첫 이용 시 1회 동의 (법무 §3-1). DesignConsentGate.js 에서 import.
export const DESIGN_CONSENT_VERSION = 'design-1.0';
export const DESIGN_CONSENT_TEXT =
    '재택·외주로 만든 완성 디자인 파일(환자 이름·치식·치과명이 들어갈 수 있음)이 자동으로 덴탈클러스터 서버(클라우드)에 보관되며, 내려받으면 삭제되고 내려받지 않아도 생성일부터 2주 뒤 자동 삭제된다는 점에 동의합니다(지그·3D 모델 결과와 결과 사진은 생성일부터 7일). 자동 보관은 설정에서 끌 수 있습니다. 이 결과에 담긴 환자 정보에 대한 처리자 책임과 환자 본인 동의 확보 책임은 외주를 맡긴 치과·기공소에 있으며, 덴탈클러스터를 쓰는 치과가 회원이 아닌 경우 이 책임은 완성본을 만든(이용) 기공소가 전적으로 부담합니다.';

function PrivacyPolicy({ onClose }) {
    const [expandedSections, setExpandedSections] = useState({});
    const v328On = isPrivacyV328On();   // 문안 §1-0 — 2026-10-23 00:00 KST 부터 본문 v3.2.8
    const [v328Open, setV328Open] = useState(false);   // 공고 상자 [바뀌는 내용 보기] — 기본 접힘(대표 10-08 "안내문이 너무 많으면 보기 안 좋다")
    const v335On = isPrivacyV335On();   // 2026-11-03 00:00 KST 부터 본문 v3.3.5 (Register.js 번호 칸 게이트와 같은 함수)
    const v335Announced = isPrivacyV335Announced();
    const [v335Open, setV335Open] = useState(false);   // v3.3.5 공고 상자 [바뀌는 내용 보기] — 기본 접힘
    const [jigNoticeOpen, setJigNoticeOpen] = useState(false);   // v3.2.9 지그 공고 상자 [바뀌는 내용 보기] — 기본 접힘
    const [designNoticeOpen, setDesignNoticeOpen] = useState(false);   // v3.3.0 완성 디자인 공고 상자 [바뀌는 내용 보기] — 기본 접힘

    const toggleSection = (sectionId) => {
        setExpandedSections(prev => ({
            ...prev,
            [sectionId]: !prev[sectionId]
        }));
    };

    return (
        <div style={styles.overlay}>
            <div style={styles.modal}>
                {/* 헤더 */}
                <div style={styles.header}>
                    <div style={styles.headerTitle}>
                        <Shield size={24} color="#6366f1" />
                        <h2 style={styles.title}>개인정보 처리방침</h2>
                    </div>
                    <button onClick={onClose} style={styles.closeButton}>
                        <X size={24} />
                    </button>
                </div>

                {/* 내용 */}
                <div style={styles.content}>
                    {/* 서문 */}
                    <div style={styles.intro}>
                        <p style={styles.introText}>
                            주식회사 덴탈클러스터(이하 "회사")는 정보주체의 자유와 권리 보호를 위해
                            「개인정보 보호법」 및 관계 법령이 정한 바를 준수하여,
                            적법하게 개인정보를 처리하고 안전하게 관리하고 있습니다.
                        </p>
                        <p style={styles.introText}>
                            본 개인정보처리방침은 회사가 제공하는 DentalCluster 서비스(웹사이트,
                            모바일 애플리케이션 등)에 적용되며, 다음과 같은 내용을 담고 있습니다.
                        </p>
                    </div>

                    {/* 📢 v3.2.8 「개정 공고」 상자 (문안 §2-4) — 공고일 이후 항상. 시행 전 = 첫 줄 + [바뀌는 내용 보기] 공고문·바뀌는 문장 전문 / 시행 뒤 = 한 줄 */}
                    <div style={styles.v328Box}>
                        <p style={{ margin: 0, fontWeight: 700 }}>{v328On ? V328_NOTICE_LINE_AFTER : V328_NOTICE_LINE_BEFORE}</p>
                        {!v328On && (
                            <button type="button" onClick={() => setV328Open(o => !o)} style={styles.v328Toggle}>
                                {v328Open ? '바뀌는 내용 접기 ▴' : '바뀌는 내용 보기 ▾'}
                            </button>
                        )}
                        {!v328On && v328Open && (
                            <div style={{ marginTop: 10 }}>
                                <p style={{ margin: '0 0 4px', fontWeight: 800 }}>{V328_NOTICE.title}</p>
                                <p style={{ margin: '0 0 10px' }}>{V328_NOTICE.dates}</p>
                                <p style={{ margin: '0 0 10px' }}><strong>{'개정 이유'}</strong>{`: ${V328_NOTICE.reason}`}</p>
                                <p style={{ margin: '0 0 4px' }}><strong>{'주요 내용'}</strong></p>
                                <div style={{ margin: '0 0 10px' }}>{V328_NOTICE.mains.map((t, i) => <p key={'v328m' + i} style={{ margin: '0 0 4px' }}>{t}</p>)}</div>
                                <p style={{ margin: '0 0 4px' }}><strong>{'바뀌는 문장 전문'}</strong></p>
                                <p style={{ margin: '6px 0 2px', fontWeight: 700 }}>{'「5. 개인정보 처리의 위탁」 기공소 간 외주 기록 절'}</p>
                                <p style={{ margin: '0 0 4px' }}>{V328_INTRO_ADD}</p>
                                <ul style={{ margin: '0 0 6px', paddingLeft: 18 }}>{V328_CHANGED_OUTSOURCE.map((t, i) => <li key={'v328c' + i} style={{ marginBottom: 4 }}>{t}</li>)}</ul>
                                <p style={{ margin: '6px 0 2px', fontWeight: 700 }}>{'「3. 개인정보의 보유 및 이용 기간」'}</p>
                                <p style={{ margin: '0 0 4px' }}>{DESIGN_LINK_LOG_LINE}</p>
                                <p style={{ margin: '0 0 4px' }}><strong>{'※ 중요:'}</strong>{` ${V328_RETENTION_WARNING}`}</p>
                                <p style={{ margin: '6px 0 2px', fontWeight: 700 }}>{'「4. 개인정보의 제3자 제공」'}</p>
                                <p style={{ margin: '0 0 4px' }}>{DESIGN_PARTNER_INFO_LINE}</p>
                                <p style={{ margin: '0 0 4px' }}>{`제공받는 자: ${DESIGN_PARTNER_INFO_ROW[0]} / 제공 목적: ${DESIGN_PARTNER_INFO_ROW[1]} / 제공 항목: ${DESIGN_PARTNER_INFO_ROW[2]}`}</p>
                                <p style={{ margin: '6px 0 2px', fontWeight: 700 }}>{'「5. 개인정보 처리의 위탁」 수탁자 지위'}</p>
                                <p style={{ margin: '0 0 4px' }}>{`…${V328_FILE_TRANSFER_TAIL}`}</p>
                                <p style={{ margin: '0 0 10px' }}>{DESIGN_PREVIEW_LINE}</p>
                                <p style={{ margin: 0 }}>{V328_NOTICE.contact}</p>
                            </div>
                        )}
                    </div>

                    {/* 📢 v3.3.5 「개정 공고」 상자 (S5 — 가입 때 면허·개설등록·허가번호) — 공고일(2026-10-27) 이후 항상. 시행 전 = 첫 줄 + [바뀌는 내용 보기] 바뀌는 글자 전체 / 시행 뒤 = 한 줄 */}
                    {v335Announced && (
                        <div style={styles.v328Box}>
                            <p style={{ margin: 0, fontWeight: 700 }}>{v335On ? V335_NOTICE_LINE_AFTER : V335_NOTICE_LINE_BEFORE}</p>
                            {!v335On && (
                                <button type="button" onClick={() => setV335Open(o => !o)} style={styles.v328Toggle}>
                                    {v335Open ? '바뀌는 내용 접기 ▴' : '바뀌는 내용 보기 ▾'}
                                </button>
                            )}
                            {!v335On && v335Open && (
                                <div style={{ marginTop: 10 }}>
                                    <p style={{ margin: '0 0 4px', fontWeight: 800 }}>{V335_NOTICE.title}</p>
                                    <p style={{ margin: '0 0 10px' }}>{V335_NOTICE.dates}</p>
                                    <p style={{ margin: '0 0 10px' }}><strong>{'개정 이유'}</strong>{`: ${V335_NOTICE.reason}`}</p>
                                    <p style={{ margin: '0 0 4px' }}><strong>{'주요 내용'}</strong></p>
                                    <div style={{ margin: '0 0 10px' }}>{V335_NOTICE.mains.map((t, i) => <p key={'v335m' + i} style={{ margin: '0 0 4px' }}>{t}</p>)}</div>
                                    <p style={{ margin: '0 0 4px' }}><strong>{'바뀌는 문장 전문'}</strong></p>
                                    <p style={{ margin: '6px 0 2px', fontWeight: 700 }}>{'「1. 개인정보의 수집 및 이용 목적」 나. 회원 관리 — 추가 항목'}</p>
                                    <ul style={{ margin: '0 0 6px', paddingLeft: 18 }}>{V335_PURPOSE_ITEMS.map((t, i) => <li key={'v335p' + i} style={{ marginBottom: 4 }}>{t}</li>)}</ul>
                                    <p style={{ margin: '6px 0 2px', fontWeight: 700 }}>{'「2. 수집하는 개인정보의 항목 및 수집 방법」 가. 수집 항목 — 업체 회원(치과/기공소) 행에 추가'}</p>
                                    <p style={{ margin: '0 0 4px' }}>{V335_LAB_MEMBER_ADD}</p>
                                    <p style={{ margin: '0 0 4px' }}>{`신설 행 「${V335_MFR_ROW[0]}」: ${V335_MFR_ROW[1]}`}</p>
                                    <p style={{ margin: '0 0 4px' }}>{`나. 수집 방법 추가: ${V335_COLLECT_METHOD_LINE}`}</p>
                                    <p style={{ margin: '6px 0 2px', fontWeight: 700 }}>{'「3. 개인정보의 보유 및 이용 기간」 — 추가 문장'}</p>
                                    <p style={{ margin: '0 0 4px' }}>{V335_RETENTION_LINE}</p>
                                    <p style={{ margin: '6px 0 2px', fontWeight: 700 }}>{'「7. 정보주체의 권리·의무 및 행사 방법」 — 열람 범위 추가 문장'}</p>
                                    <p style={{ margin: '0 0 10px' }}>{V335_ACCESS_LINE}</p>
                                    <p style={{ margin: 0 }}>{V335_NOTICE.contact}</p>
                                </div>
                            )}
                        </div>
                    )}

                    {/* 📢 v3.2.9 지그 결과 클라우드 보관 「개정 공고」 상자 (법무 §2·§3) — 공고일(2026-10-21)부터 노출, 시행(2026-10-28)·서버 jigWeb 과 별개. 게시 끝 2026-11-04 */}
                    {isPrivacyJigNoticePeriod && (
                        <div style={styles.v328Box}>
                            <p style={{ margin: 0, fontWeight: 700 }}>{isPrivacyJigOn ? PRIVACY_JIG_NOTICE.lineAfter : PRIVACY_JIG_NOTICE.lineBefore}</p>
                            {/* 공고 기간엔 시행 여부와 무관하게 바뀌는 내용(§2)을 볼 수 있게 둔다(당일 시행 시에도 고지 문안 노출) */}
                            <button type="button" onClick={() => setJigNoticeOpen(o => !o)} style={styles.v328Toggle}>
                                {jigNoticeOpen ? '바뀌는 내용 접기 ▴' : '바뀌는 내용 보기 ▾'}
                            </button>
                            {jigNoticeOpen && (
                                <div style={{ marginTop: 10 }}>
                                    <p style={{ margin: '0 0 4px', fontWeight: 800 }}>{PRIVACY_JIG_NOTICE.title}</p>
                                    <p style={{ margin: '0 0 10px' }}>{PRIVACY_JIG_NOTICE.dates}</p>
                                    <p style={{ margin: '0 0 10px' }}><strong>{'개정 이유'}</strong>{`: ${PRIVACY_JIG_NOTICE.reason}`}</p>
                                    <p style={{ margin: '0 0 4px' }}><strong>{'바뀌는 내용'}</strong></p>
                                    <div style={{ margin: '0 0 10px' }}>{PRIVACY_JIG_NOTICE.mains.map((t, i) => <p key={'jignm' + i} style={{ margin: '0 0 4px' }}>{t}</p>)}</div>
                                    <p style={{ margin: 0 }}>{PRIVACY_JIG_NOTICE.contact}</p>
                                </div>
                            )}
                        </div>
                    )}

                    {/* 📢 v3.3.0 완성 디자인 산출물 클라우드 보관 「개정 공고」 상자 (법무 §2·§3) — 공고일(2026-10-21)부터 노출, 게시 끝 2026-11-04 */}
                    {isPrivacyDesignNoticePeriod && (
                        <div style={styles.v328Box}>
                            <p style={{ margin: 0, fontWeight: 700 }}>{isPrivacyDesignOn ? PRIVACY_DESIGN_NOTICE.lineAfter : PRIVACY_DESIGN_NOTICE.lineBefore}</p>
                            {/* 공고 기간엔 시행 여부와 무관하게 바뀌는 내용(§2)을 볼 수 있게 둔다(당일 시행 시에도 고지 문안 노출) */}
                            <button type="button" onClick={() => setDesignNoticeOpen(o => !o)} style={styles.v328Toggle}>
                                {designNoticeOpen ? '바뀌는 내용 접기 ▴' : '바뀌는 내용 보기 ▾'}
                            </button>
                            {designNoticeOpen && (
                                <div style={{ marginTop: 10 }}>
                                    <p style={{ margin: '0 0 4px', fontWeight: 800 }}>{PRIVACY_DESIGN_NOTICE.title}</p>
                                    <p style={{ margin: '0 0 10px' }}>{PRIVACY_DESIGN_NOTICE.dates}</p>
                                    <p style={{ margin: '0 0 10px' }}><strong>{'개정 이유'}</strong>{`: ${PRIVACY_DESIGN_NOTICE.reason}`}</p>
                                    <p style={{ margin: '0 0 4px' }}><strong>{'바뀌는 내용'}</strong></p>
                                    <div style={{ margin: '0 0 10px' }}>{PRIVACY_DESIGN_NOTICE.mains.map((t, i) => <p key={'dsgnm' + i} style={{ margin: '0 0 4px' }}>{t}</p>)}</div>
                                    <p style={{ margin: 0 }}>{PRIVACY_DESIGN_NOTICE.contact}</p>
                                </div>
                            )}
                        </div>
                    )}

                    {/* 목차 */}
                    <div style={styles.tocBox}>
                        <h3 style={styles.tocTitle}>목차</h3>
                        <ul style={styles.tocList}>
                            <li>1. 개인정보의 수집 및 이용 목적</li>
                            <li>2. 수집하는 개인정보의 항목 및 수집 방법</li>
                            <li>3. 개인정보의 보유 및 이용 기간</li>
                            <li>4. 개인정보의 제3자 제공</li>
                            <li>5. 개인정보 처리의 위탁</li>
                            <li>6. 개인정보의 파기 절차 및 방법</li>
                            <li>7. 정보주체의 권리·의무 및 행사 방법</li>
                            <li>8. 개인정보의 안전성 확보 조치</li>
                            <li>9. 개인정보 자동 수집 장치의 설치·운영 및 거부</li>
                            <li>10. 개인정보 보호책임자</li>
                            <li>11. 개인정보 처리방침의 변경</li>
                            <li>12. 아동의 개인정보 보호</li>
                        </ul>
                    </div>

                    {/* 섹션 1 */}
                    <Section
                        id="section1"
                        title="1. 개인정보의 수집 및 이용 목적"
                        expanded={expandedSections.section1}
                        onToggle={() => toggleSection('section1')}
                    >
                        <p style={styles.text}>
                            회사는 수집한 개인정보를 다음의 목적을 위해 활용합니다.
                            이용자가 제공한 모든 정보는 하기 목적에 필요한 용도 이외로는 사용되지 않으며,
                            이용 목적이 변경될 시에는 사전 동의를 구할 것입니다.
                        </p>

                        <div style={styles.subSection}>
                            <h4 style={styles.subTitle}>가. 서비스 제공에 관한 계약 이행 및 서비스 제공에 따른 요금정산</h4>
                            <ul style={styles.list}>
                                <li>회원 가입, 본인 확인 및 사업자등록번호 진위 확인</li>
                                <li>치과 및 치과기공소 간 의뢰서 작성 및 관리</li>
                                <li>월정액 구독료 결제 및 환불 처리</li>
                                <li>거래명세서 및 전자세금계산서 발행 (팝빌 연동)</li>
                                <li>마켓플레이스 상품 구매 및 배송</li>
                                <li>중고물품 거래 중개 및 연락처 제공</li>
                                <li>채팅 서비스 제공 및 파일 공유</li>
                                <li>캘린더 및 일정 관리</li>
                                <li>매출·리메이크율 통계 및 경영분석 리포트 제공</li>
                                <li>치과·기공소 홍보 페이지 공개 및 검색 노출</li>
                                <li>홍보 대행 서비스 (카페 바이럴, 메타 광고, 배너, 직접 영업)</li>
                                <li>환자 리뷰 수집(QR 익명 태그 방식) 및 표시 관리</li>
                                <li>지역 기반 매칭 (시·군·구 단위 우선 노출)</li>
                                {V324 && <li>{V324.purposeLine}</li>}
                            </ul>
                        </div>

                        <div style={styles.subSection}>
                            <h4 style={styles.subTitle}>나. 회원 관리</h4>
                            <ul style={styles.list}>
                                <li>회원제 서비스 이용에 따른 본인 확인</li>
                                <li>개인 식별, 불량회원의 부정 이용 방지와 비인가 사용 방지</li>
                                <li>가입 의사 확인, 연령 확인</li>
                                <li>불만 처리 등 민원 처리, 고지사항 전달</li>
                                <li>직원 계정 관리 (업체 오너용)</li>
                                <li>판매자 승인 및 스토어 관리</li>
                                <li>마케터 승인 및 관리</li>
                                {v335On && V335_PURPOSE_ITEMS.map((t, i) => <li key={'v335pu' + i}>{t}</li>)}   {/* v3.3.5 법무 §2-5 */}
                            </ul>
                        </div>

                        <div style={styles.subSection}>
                            <h4 style={styles.subTitle}>다. 마케팅 및 광고에 활용</h4>
                            <ul style={styles.list}>
                                <li>신규 서비스(제품) 개발 및 맞춤 서비스 제공</li>
                                <li>이벤트 및 광고성 정보 제공 및 참여 기회 제공</li>
                                <li>접속 빈도 파악 또는 회원의 서비스 이용에 대한 통계</li>
                                <li>마케팅 콘텐츠 제작 및 발행 대행</li>
                            </ul>
                        </div>

                        <div style={styles.subSection}>
                            <h4 style={styles.subTitle}>라. 거래 안전성 확보</h4>
                            <ul style={styles.list}>
                                <li>부정거래 방지 및 거래 분쟁 조정</li>
                                <li>결제 사기 탐지 및 예방</li>
                                <li>이용 제한 조치 확인</li>
                                <li>중고물품 허위 매물 방지</li>
                            </ul>
                        </div>
                    </Section>

                    {/* 섹션 2 */}
                    <Section
                        id="section2"
                        title="2. 수집하는 개인정보의 항목 및 수집 방법"
                        expanded={expandedSections.section2}
                        onToggle={() => toggleSection('section2')}
                    >
                        <div style={styles.subSection}>
                            <h4 style={styles.subTitle}>가. 수집하는 개인정보 항목</h4>

                            <div style={styles.tableBox}>
                                <table style={styles.table}>
                                    <thead>
                                        <tr style={styles.tableHeaderRow}>
                                            <th style={styles.tableHeader}>구분</th>
                                            <th style={styles.tableHeader}>수집 항목</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr style={styles.tableRow}>
                                            <td style={styles.tableCell}><strong>필수 항목<br/>(모든 회원)</strong></td>
                                            <td style={styles.tableCell}>
                                                이메일, 비밀번호, 이름, 전화번호, 회원 유형
                                            </td>
                                        </tr>
                                        <tr style={styles.tableRow}>
                                            <td style={styles.tableCell}><strong>업체 회원<br/>(치과/기공소)</strong></td>
                                            <td style={styles.tableCell}>
                                                업체명, 사업자등록번호, 주소, 대표자명,<br/>
                                                업체 유형(치과/기공소){v328On && V328_BIZ_MEMBER_ADD}
                                                {v335On && <><br/>{V335_LAB_MEMBER_ADD}</>}   {/* v3.3.5 법무 §2-5 */}
                                            </td>
                                        </tr>
                                        {v335On && (
                                            <tr style={styles.tableRow}>
                                                <td style={styles.tableCell}><strong>{V335_MFR_ROW[0]}</strong></td>
                                                <td style={styles.tableCell}>{V335_MFR_ROW[1]}</td>
                                            </tr>
                                        )}
                                        <tr style={styles.tableRow}>
                                            <td style={styles.tableCell}><strong>판매자 회원</strong></td>
                                            <td style={styles.tableCell}>
                                                사업자등록번호, 사업자등록증 사본,<br/>
                                                정산 계좌 정보, 스토어명, 스토어 로고,<br/>
                                                스토어 배너, 스토어 설명, 스토어 연락처
                                            </td>
                                        </tr>
                                        <tr style={styles.tableRow}>
                                            <td style={styles.tableCell}><strong>마케터 회원</strong></td>
                                            <td style={styles.tableCell}>
                                                이름, 연락처, 포트폴리오,<br/>
                                                마케팅 전문 분야, 경력 사항
                                            </td>
                                        </tr>
                                        <tr style={styles.tableRow}>
                                            <td style={styles.tableCell}><strong>중고물품<br/>판매자</strong></td>
                                            <td style={styles.tableCell}>
                                                판매자명, 연락처, 이메일,<br/>
                                                상품 사진, 상품 설명
                                            </td>
                                        </tr>
                                        <tr style={styles.tableRow}>
                                            <td style={styles.tableCell}><strong>서비스 이용 중<br/>생성 정보</strong></td>
                                            <td style={styles.tableCell}>
                                                주문 내역, 결제 정보, 배송 정보, 채팅 내역,<br/>
                                                파일 업로드 정보, 거래명세서, 전자세금계산서,<br/>
                                                통계 데이터, 광고/세미나 등록 정보,<br/>
                                                중고물품 등록 정보, 마케팅 콘텐츠,<br/>
                                                구독 결제 내역{v328On && <>{','}<br/>{V328_GENERATED_ADD}</>}{isPrivacyJigOn && <>{','}<br/>{'지그·3D 모델 결과 파일과 결과 사진(음각 환자 이름·치식·치과명 포함)'}</>}{isPrivacyDesignOn && <>{','}<br/>{'완성 디자인 결과 파일(음각 환자 이름(실명)·치식·치과명 포함)'}</>}{','}<br/>{'거래처별 입금 기록·청구 마감일(기공소 회원이 직접 입력)'}
                                                {/* v3.3.2 계약 §2 (2026-10-24) — 법무 고정 문구 */}
                                                {','}<br/>{'공유 링크 확인자 이름, 수정 요청 내용(비회원 치과 담당자 입력) — 보유: 공유 링크와 같음'}
                                            </td>
                                        </tr>
                                        <tr style={styles.tableRow}>
                                            <td style={styles.tableCell}><strong>홍보 페이지<br/>등록 정보</strong></td>
                                            <td style={styles.tableCell}>
                                                업체 로고, 외관/내부 사진, 의료인 정보(이름·면허·약력),<br/>
                                                진료과목, 보유 장비, 사용 재료, 부대시설,<br/>
                                                진료 시간, 휴진일, 카카오맵 좌표
                                            </td>
                                        </tr>
                                        <tr style={styles.tableRow}>
                                            <td style={styles.tableCell}><strong>환자 리뷰<br/>(익명)</strong></td>
                                            <td style={styles.tableCell}>
                                                선택형 태그(친절·청결·전문성 등), 작성 일시,<br/>
                                                작성자 IP(스팸 방지용 해시 저장)<br/>
                                                ※ 환자 본인의 이름·연락처는 수집하지 않음
                                            </td>
                                        </tr>
                                        <tr style={styles.tableRow}>
                                            <td style={styles.tableCell}><strong>방문자 통계<br/>(유입 분석)</strong></td>
                                            <td style={styles.tableCell}>
                                                IP 기반 대략적 위치(시·도·시군구), 방문 시각,<br/>
                                                조회한 치과·기공소 식별자, 디바이스 종류<br/>
                                                ※ 통계 목적이며 개인 식별 불가
                                            </td>
                                        </tr>
                                        {V324 && (
                                            <tr style={styles.tableRow}>
                                                <td style={styles.tableCell}><strong>{V324.collectRow.label}</strong></td>
                                                <td style={styles.tableCell}>{V324.collectRow.items}</td>
                                            </tr>
                                        )}
                                        <tr style={styles.tableRow}>
                                            <td style={styles.tableCell}><strong>자동 수집 항목</strong></td>
                                            <td style={styles.tableCell}>
                                                IP 주소, 쿠키, 서비스 이용 기록,<br/>
                                                접속 로그, 기기 정보, OS 정보,<br/>
                                                브라우저 정보, 위치 정보(선택 시 GPS),<br/>
                                                덴클 프로그램 설치 PC의 기기명·연결 폴더 경로·프로그램 버전,<br/>
                                                모바일 앱: 푸시 알림 토큰, 알림 수신·열람 기록(서비스 알림 제공 목적, 탈퇴·토큰 만료 시 삭제)
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <div style={styles.subSection}>
                            <h4 style={styles.subTitle}>나. 개인정보 수집 방법</h4>
                            <ul style={styles.list}>
                                <li>홈페이지 및 모바일 앱을 통한 회원가입, 서비스 이용</li>
                                <li>판매자/마케터 승인 신청 시 제출 서류</li>
                                <li>중고물품 등록 시 입력 정보</li>
                                <li>스토어 설정 시 입력 정보</li>
                                <li>생성정보 수집 툴을 통한 자동 수집</li>
                                <li>고객센터를 통한 전화, 이메일, 팩스 등</li>
                                {v335On && <li>{V335_COLLECT_METHOD_LINE}</li>}   {/* v3.3.5 법무 §2-5 */}
                                {V324 && <li>{V324.collectMethodLine}</li>}
                            </ul>
                        </div>
                    </Section>

                    {/* 섹션 3 */}
                    <Section
                        id="section3"
                        title="3. 개인정보의 보유 및 이용 기간"
                        expanded={expandedSections.section3}
                        onToggle={() => toggleSection('section3')}
                    >
                        <p style={styles.text}>
                            회사는 이용자의 개인정보를 <strong>회원 탈퇴 시까지</strong> 보유하며,
                            관련 법령에 따라 아래와 같이 일정 기간 보관합니다.
                        </p>
                        <p style={styles.text}>
                            {'다만 회사가 의료기관·치과기공소의 위탁을 받아 처리하는 환자 정보(의뢰서, 기공소 간 외주 기록 등)의 보유 기간은 「5. 개인정보 처리의 위탁」에 적은 기간에 따릅니다. 치과기공물제작의뢰서를 2년 보존할 법적 의무는 치과의사와 치과기공소에 있습니다(「의료기사 등에 관한 법률 시행규칙」).'}   {/* v3.2.7 정본 §1-6 */}
                        </p>
                        {v328On && <p style={styles.text}>{DESIGN_LINK_LOG_LINE}</p>}   {/* v3.2.8 문안 §1-4 [변호사 확인 필요 V-F] */}
                        {v335On && <p style={styles.text}>{V335_RETENTION_LINE}</p>}   {/* v3.3.5 법무 §2-5 — 번호 파기 시점·심사 기록 3년 */}
                        {isPrivacyJigOn && <p style={styles.text}>{'지그·3D 모델 결과와 결과 사진의 보유 기간은 「5. 개인정보 처리의 위탁」의 [치과 지그 결과의 처리] 절에 따릅니다(생성일부터 7일).'}</p>}   {/* 지그 웹 a안 동반 수정 (법무 §1-4) */}
                        {/* v3.3.2 계약 §2 (2026-10-24) — 법무 고정 문구 */}
                        <p style={styles.text}>{'공유 링크: 기공소 회원이 치과에 보내는 거래명세서 확인 링크로, 환자 이름은 가운데를 가린 값만 담습니다. 생성일부터 60일 동안 열람할 수 있고, 기간이 지나면 열람이 차단되며 30일 이내 삭제합니다.'}</p>
                        {isPrivacyDesignOn && <p style={styles.text}>{'완성 디자인 결과의 보유 기간은 「5. 개인정보 처리의 위탁」의 [완성 디자인 산출물의 처리] 절에 따릅니다(생성일부터 14일 보관, 보관 기간 안에는 다시 내려받기 가능, 14일이 지나면 자동 삭제).'}</p>}   {/* 완성 디자인 A 동반 수정 (법무 §1-3) */}
                        {V324 && <p style={styles.text}>{V324.retentionLine}</p>}

                        <div style={styles.tableBox}>
                            <table style={styles.table}>
                                <thead>
                                    <tr style={styles.tableHeaderRow}>
                                        <th style={styles.tableHeader}>보존 항목</th>
                                        <th style={styles.tableHeader}>근거 법령</th>
                                        <th style={styles.tableHeader}>보존 기간</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr style={styles.tableRow}>
                                        <td style={styles.tableCell}>계약 또는 청약철회 등에 관한 기록</td>
                                        <td style={styles.tableCell}>전자상거래법</td>
                                        <td style={styles.tableCell}>5년</td>
                                    </tr>
                                    <tr style={styles.tableRow}>
                                        <td style={styles.tableCell}>대금결제 및 재화 등의 공급에 관한 기록</td>
                                        <td style={styles.tableCell}>전자상거래법</td>
                                        <td style={styles.tableCell}>5년</td>
                                    </tr>
                                    <tr style={styles.tableRow}>
                                        <td style={styles.tableCell}>소비자 불만 또는 분쟁처리에 관한 기록</td>
                                        <td style={styles.tableCell}>전자상거래법</td>
                                        <td style={styles.tableCell}>3년</td>
                                    </tr>
                                    {/* v3.2.7(정본 §1-6): 「치과기공물 의뢰서/의료기사법 시행규칙/2년」 줄 삭제 — 법정 보존 의무자는 치과의사·치과기공소(위 문단) */}
                                    <tr style={styles.tableRow}>
                                        <td style={styles.tableCell}>표시/광고에 관한 기록</td>
                                        <td style={styles.tableCell}>전자상거래법</td>
                                        <td style={styles.tableCell}>6개월</td>
                                    </tr>
                                    <tr style={styles.tableRow}>
                                        <td style={styles.tableCell}>웹사이트 방문 기록</td>
                                        <td style={styles.tableCell}>통신비밀보호법</td>
                                        <td style={styles.tableCell}>3개월</td>
                                    </tr>
                                    <tr style={styles.tableRow}>
                                        <td style={styles.tableCell}>중고물품 거래 기록</td>
                                        <td style={styles.tableCell}>전자상거래법</td>
                                        <td style={styles.tableCell}>5년</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <div style={styles.warningBox}>
                            <p style={styles.warningText}>
                                <strong>※ 중요:</strong>{' '}
                                {v328On ? V328_RETENTION_WARNING : '회원 탈퇴 시 즉시 파기됨이 원칙이나, 위 법령에 따라 보존이 필요한 정보는 별도 저장 후 관리됩니다.'}
                            </p>
                        </div>
                    </Section>

                    {/* 섹션 4 */}
                    <Section
                        id="section4"
                        title="4. 개인정보의 제3자 제공"
                        expanded={expandedSections.section4}
                        onToggle={() => toggleSection('section4')}
                    >
                        <p style={styles.text}>
                            회사는 원칙적으로 이용자의 개인정보를 외부에 제공하지 않습니다.
                            다만, 아래의 경우에는 예외로 합니다:
                        </p>

                        <div style={styles.subSection}>
                            <h4 style={styles.subTitle}>가. 이용자가 사전에 동의한 경우</h4>
                            <ul style={styles.list}>
                                <li>치과와 기공소 간 주문서 공유 (상호 간 동의)</li>
                                <li>마켓플레이스 판매자에게 구매자 배송 정보 제공</li>
                                <li>중고물품 판매자와 구매자 간 연락처 공유</li>
                                <li>마케팅 대행 시 의뢰인과 마케터 간 정보 공유</li>
                                <li>광고/세미나 주최사에게 참가자 정보 제공 (사전 동의 시)</li>
                                {v328On && <li>{DESIGN_PARTNER_INFO_LINE}</li>}
                            </ul>
                        </div>

                        <div style={styles.subSection}>
                            <h4 style={styles.subTitle}>나. 법령의 규정에 의한 경우</h4>
                            <ul style={styles.list}>
                                <li>관계 법령에 의거 적법한 절차에 의한 정부/수사기관의 요청이 있는 경우</li>
                                <li>통계작성, 학술연구, 시장조사를 위해 특정 개인을 식별할 수 없는 형태로 제공하는 경우</li>
                                {/* v3.3.2 계약 §2 (2026-10-24) — 법무 고정 문구 */}
                                <li>{'회원이 발행한 전자세금계산서·전자계산서의 기재 정보(사업자등록번호·상호·대표자명·주소·이메일·공급가액 등)를 관계 세법에 따라 국세청에 전송합니다(팝빌을 통해).'}</li>
                            </ul>
                        </div>

                        <div style={styles.tableBox}>
                            <table style={styles.table}>
                                <thead>
                                    <tr style={styles.tableHeaderRow}>
                                        <th style={styles.tableHeader}>제공받는 자</th>
                                        <th style={styles.tableHeader}>제공 목적</th>
                                        <th style={styles.tableHeader}>제공 항목</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr style={styles.tableRow}>
                                        <td style={styles.tableCell}>마켓플레이스 판매자</td>
                                        <td style={styles.tableCell}>상품 배송</td>
                                        <td style={styles.tableCell}>수령인명, 연락처, 배송주소</td>
                                    </tr>
                                    <tr style={styles.tableRow}>
                                        <td style={styles.tableCell}>중고물품 거래 상대방</td>
                                        <td style={styles.tableCell}>거래 연락</td>
                                        <td style={styles.tableCell}>이름, 연락처</td>
                                    </tr>
                                    <tr style={styles.tableRow}>
                                        <td style={styles.tableCell}>마케팅 의뢰인/마케터</td>
                                        <td style={styles.tableCell}>마케팅 대행</td>
                                        <td style={styles.tableCell}>이름, 연락처, 업체 정보</td>
                                    </tr>
                                    {v328On && (
                                        <tr style={styles.tableRow}>
                                            {DESIGN_PARTNER_INFO_ROW.map((c, i) => <td key={'v328r' + i} style={styles.tableCell}>{c}</td>)}
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </Section>

                    {/* 섹션 5 */}
                    <Section
                        id="section5"
                        title="5. 개인정보 처리의 위탁"
                        expanded={expandedSections.section5}
                        onToggle={() => toggleSection('section5')}
                    >
                        <p style={styles.text}>
                            회사는 원활한 서비스 제공을 위해 다음과 같이 개인정보 처리 업무를 외부 전문업체에 위탁하고 있습니다.
                        </p>

                        <div style={styles.tableBox}>
                            <table style={styles.table}>
                                <thead>
                                    <tr style={styles.tableHeaderRow}>
                                        <th style={styles.tableHeader}>수탁업체</th>
                                        <th style={styles.tableHeader}>위탁 업무 내용</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr style={styles.tableRow}>
                                        <td style={styles.tableCell}>Google Firebase<br/>(Google LLC)</td>
                                        <td style={styles.tableCell}>데이터 저장, 사용자 인증, 푸시 알림, 파일 저장, Cloud Functions 실행</td>
                                    </tr>
                                    {/* v3.2.3 — 구독 정기결제 PG 토스페이먼츠 추가 (개인정보보호법 §26②) */}
                                    <tr style={styles.tableRow}>
                                        <td style={styles.tableCell}>토스페이먼츠<br/>(토스페이먼츠 주식회사)</td>
                                        <td style={styles.tableCell}>전자결제 대행 (구독 정기결제·결제 카드 등록)</td>
                                    </tr>
                                    {/* [메인 2026-10-24] KISPG 행은 넣지 않는다 — 코드 기본값(features.js pgProvider 'kispg')은 폴백일 뿐, 운영 config/features.pgProvider='toss'·billingKeys provider toss만(KISPG bid 0건) 확인. 실제 처리 수탁자 = 토스페이먼츠. */}
                                    <tr style={styles.tableRow}>
                                        <td style={styles.tableCell}>포트원/포트원<br/>(주식회사 코리아포트원)</td>
                                        <td style={styles.tableCell}>전자결제 대행 (구독 결제·마켓플레이스 결제)</td>
                                    </tr>
                                    <tr style={styles.tableRow}>
                                        <td style={styles.tableCell}>팝빌<br/>(주식회사 링크허브)</td>
                                        <td style={styles.tableCell}>{'전자세금계산서·전자계산서 발행 대행 및 국세청 전송, 발행 안내 메일 발송'}</td>   {/* v3.3.2 계약 §2 (2026-10-24) */}
                                    </tr>
                                    <tr style={styles.tableRow}>
                                        <td style={styles.tableCell}>카카오<br/>(주식회사 카카오)</td>
                                        <td style={styles.tableCell}>주소 검색 API, 카카오맵 좌표 변환 및 지도 표시</td>
                                    </tr>
                                    <tr style={styles.tableRow}>
                                        <td style={styles.tableCell}>국세청 홈택스</td>
                                        <td style={styles.tableCell}>사업자등록번호 진위 확인 (가입 시 1회)</td>
                                    </tr>
                                    <tr style={styles.tableRow}>
                                        <td style={styles.tableCell}>ipapi.co<br/>(IP 위치 조회)</td>
                                        <td style={styles.tableCell}>방문자 IP 기반 대략 지역(시·도) 정보 변환 (개인 식별 불가)</td>
                                    </tr>
                                    <tr style={styles.tableRow}>
                                        <td style={styles.tableCell}>택배사<br/>(CJ대한통운 등)</td>
                                        <td style={styles.tableCell}>마켓플레이스 상품 배송</td>
                                    </tr>
                                    {V324 && V324.trusteeRows.map(t => (
                                        <tr key={t.name} style={styles.tableRow}>
                                            <td style={styles.tableCell}>{t.name}</td>
                                            <td style={styles.tableCell}>{t.work}</td>
                                        </tr>
                                    ))}
                                    <tr style={styles.tableRow}>
                                        <td style={styles.tableCell}>네이버·메타(Meta)<br/>광고 매체</td>
                                        <td style={styles.tableCell}>치과 홍보 대행 (카페 게시글, 인스타그램·페이스북 광고 집행)</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <p style={styles.text}>
                            회사는 위탁계약 체결 시 개인정보보호법 제26조에 따라
                            위탁업무 수행목적 외 개인정보 처리금지, 기술적·관리적 보호조치,
                            재위탁 제한, 수탁자에 대한 관리·감독, 손해배상 등 책임에 관한 사항을
                            계약서 등 문서에 명시하고, 수탁자가 개인정보를 안전하게 처리하는지를 감독하고 있습니다.
                        </p>

                        <p style={{ ...styles.text, fontWeight: 700, marginTop: 16 }}>
                            [환자 개인정보에 대한 회사의 수탁자 지위] (v5.0)
                        </p>
                        <p style={styles.text}>
                            의뢰서·거래명세서·파일 전송 서비스에서 환자 개인정보(성명, 치식, 보철 정보, 구강 스캔 데이터 등)의
                            개인정보처리자는 해당 의료기관 및 치과기공소이며, 회사는 이용약관 제4조의7에 따라
                            해당 처리 업무를 위탁받은 <strong>수탁자</strong>의 지위에서 처리합니다.
                            회사는 위탁 목적 범위를 넘어 환자 개인정보를 이용하거나 제3자에게 제공하지 않습니다.
                        </p>
                        <p style={styles.text}>
                            파일 전송(구강 스캔·CAD 케이스)을 위해 회사 서버에 일시 저장되는 파일은
                            수신 확인 후 24시간 이내, 늦어도 7일 이내 {v328On ? V328_FILE_TRANSFER_TAIL : '자동 삭제되며 전송 구간은 암호화됩니다.'}
                            환자 본인의 개인정보 수집·이용 동의 확보 책임은 해당 의료기관에 있습니다.
                        </p>
                        {v328On && <p style={styles.text}>{DESIGN_PREVIEW_LINE}</p>}   {/* v3.2.8 문안 §1-6 */}

                        {/* 지그 웹 a안 — "보관 안 함" 원칙은 전달용 파일(스캔·CAD) 한정이고 지그 결과는 예외임을 명시 (법무 §1-2). 시행 전엔 숨김 */}
                        {isPrivacyJigOn && (
                            <p style={styles.text}>
                                {'위 "일시 저장 후 자동 삭제" 원칙은 전달만 하는 파일(구강 스캔·CAD 케이스)에 적용됩니다. 다만 아래 [치과 지그 결과의 처리] 절에 적은 지그·3D 모델 결과 파일과 결과 사진은 기공소의 조회·내려받기를 위해 예외적으로 회사 서버에 일정 기간(생성일부터 7일) 보관한 뒤 자동 삭제합니다.'}
                            </p>
                        )}

                        {/* 지그 웹 a안 — [치과 지그 결과의 처리] (법무 docs/지그웹a_처리방침동의_2026-10.md §1-3). 시행일(PRIVACY_JIG_EFFECTIVE_ISO) 확정 전엔 숨김 */}
                        {isPrivacyJigOn && (
                            <>
                                <p style={{ ...styles.text, fontWeight: 700, marginTop: 16 }}>
                                    {`[치과 지그 결과의 처리] (${PRIVACY_JIG_VERSION}, ${PRIVACY_JIG_DATE}부터 적용 · ${PRIVACY_JIG7_VERSION}, ${PRIVACY_JIG7_DATE} 개정)`}
                                </p>
                                <p style={styles.text}>
                                    {'치과기공소 회원이 의뢰받은 보철 작업을 위해 회사가 제공하는 지그(치과 작업 보조 틀)·3D 모델 자동 생성 기능을 이용하면, 그 결과 파일과 결과 사진에는 환자 정보가 들어 있습니다. 이 환자 정보는 치과가 기공소에 맡긴 것이고, 회사는 해당 기공소의 위탁을 받은 수탁자로서 결과 파일을 저장하고, 그 기공소에만 보여 주며, 아래 기간이 지나면 삭제합니다.'}
                                </p>
                                <ul style={styles.list}>
                                    {JIG_RESULT_ITEMS.map((t, i) => <li key={'jig' + i}>{t}</li>)}
                                </ul>
                            </>
                        )}

                        {/* 완성 디자인 A — "보관 안 함" 원칙은 전달용 파일(스캔·CAD 중간) 한정이고 완성 산출물은 예외임을 명시 (법무 §1-2). 시행 전엔 숨김 */}
                        {isPrivacyDesignOn && (
                            <p style={styles.text}>
                                {'다만 아래 [완성 디자인 산출물의 처리] 절에 적은 완성 디자인 파일(재택·외주 완성 STL)은 기공소의 조회·내려받기를 위해 예외적으로 회사 서버에 생성일부터 2주 동안 보관한 뒤 자동 삭제합니다(지그·3D 모델 결과와 결과 사진은 위 [치과 지그 결과의 처리] 절에 따라 7일). 그 전 단계의 전달용 파일(구강 스캔·CAD 중간 작업파일 등)은 종전처럼 거쳐 전달만 하고 보관하지 않습니다.'}
                            </p>
                        )}

                        {/* 완성 디자인 A — [완성 디자인 산출물의 처리] (법무 docs/완성디자인STL_A_처리방침개정_고지준비_2026-10-21.md §1-1). 시행일(PRIVACY_DESIGN_EFFECTIVE_ISO) 전엔 숨김 */}
                        {isPrivacyDesignOn && (
                            <>
                                <p style={{ ...styles.text, fontWeight: 700, marginTop: 16 }}>
                                    {`[완성 디자인 산출물의 처리] (${PRIVACY_DESIGN_VERSION}, ${PRIVACY_DESIGN_DATE}부터 적용)`}
                                </p>
                                <p style={styles.text}>
                                    {'치과기공소 회원이 의뢰받은 보철 작업의 컴퓨터지원설계(CAD)를 마친 완성 디자인 파일(STL 등. 재택·외주 결과. 지그·3D 모델 결과와 결과 사진은 위 [치과 지그 결과의 처리] 절에 따릅니다)에는 환자 정보가 들어 있습니다. 이 환자 정보는 치과가 기공소에 맡긴 것이고, 회사는 해당 기공소의 위탁을 받은 수탁자로서 완성 파일을 저장하고, 그 기공소에만 보여 주며, 아래 기간이 지나면 삭제합니다.'}
                                </p>
                                <ul style={styles.list}>
                                    {DESIGN_RESULT_ITEMS.map((t, i) => <li key={'dsgn' + i}>{t}</li>)}
                                </ul>
                            </>
                        )}

                        {/* v3.2.7 — 기공소 간 외주(CAD 디자인·제작) 기록의 처리 (정본_처리방침_외주기록 §1, V324 조건과 무관하게 항상) */}
                        <p style={{ ...styles.text, fontWeight: 700, marginTop: 16 }}>
                            {v328On
                                ? `[기공소 간 외주(CAD 디자인·제작) 기록의 처리] (v3.2.8, ${PRIVACY_V328_DATE}부터 적용)`
                                : `[기공소 간 외주(CAD 디자인·제작) 기록의 처리] (v3.2.7, ${PRIVACY_V327_DATE}부터 적용)`}
                        </p>
                        <p style={styles.text}>
                            {'치과기공소 회원(이하 "보내는 기공소")이 덴클에서 다른 회원(치과기공소 또는 외주 제작 업체, 이하 "받는 곳")에게 CAD 디자인이나 보철물 제작 공정의 일부를 맡긴 기록에는 환자 정보가 들어 있습니다. 이 환자 정보는 치과가 보내는 기공소에 맡긴 것이고, 보내는 기공소가 다시 받는 곳에 맡기는 것(재위탁)입니다. 회사는 보내는 기공소의 위탁을 받은 수탁자로서 이 기록을 저장하고, 보내는 기공소와 받는 곳에 보여 주며, 아래 기간이 지나면 삭제합니다.'}
                            {v328On && ` ${V328_INTRO_ADD}`}
                        </p>
                        <ul style={styles.list}>
                            {(v328On ? OUTSOURCE_RECORD_ITEMS_V328 : OUTSOURCE_RECORD_ITEMS).map((t, i) => <li key={'oo' + i}>{t}</li>)}
                        </ul>

                        {/* v3.2.1 — 치과 데스크 접수 기록의 처리 (정본 §4-1·§7-4-1) */}
                        <p style={{ ...styles.text, fontWeight: 700, marginTop: 16 }}>
                            {`[치과 데스크 접수 기록의 처리] (v3.2.1, ${PRIVACY_V321_DATE}부터 적용)`}
                        </p>
                        <p style={styles.text}>
                            {'회사 회원인 의료기관(치과)이 데스크에 비치한 접수 QR로 환자가 직접 작성한 접수 기록의 개인정보처리자는 해당 의료기관이며, 회사는 그 의료기관의 위탁을 받은 수탁자로서 처리합니다.'}
                        </p>
                        <ul style={styles.list}>
                            {DESK_RECEPTION_ITEMS.map((t) => <li key={t.slice(0, 12)}>{t}</li>)}
                        </ul>

                        {/* v3.2.4 — 치과 환자 앱 등록·보철물 제작 기록의 처리(정본 §4-4ⓑ) + 개인정보의 국외 이전(§4-5) */}
                        {V324 && (
                            <>
                                <p style={{ ...styles.text, fontWeight: 700, marginTop: 16 }}>{`${V324.recordSection.title} (${V324.version}, ${V324.effectiveDate}부터 적용)`}</p>
                                <p style={styles.text}>{V324.recordSection.intro}</p>
                                <ul style={styles.list}>
                                    {V324.recordSection.items.map((t) => <li key={t.slice(0, 16)}>{t}</li>)}
                                </ul>
                                <p style={{ ...styles.text, fontWeight: 700, marginTop: 16 }}>{V324.overseas.title}</p>
                                <div style={styles.tableBox}>
                                    <table style={styles.table}>
                                        <thead>
                                            <tr style={styles.tableHeaderRow}>
                                                {['이전받는 자(연락처)', '이전 국가', '이전 일시·방법', '이전 항목', '이용 목적', '보유·이용 기간'].map(h => <th key={h} style={styles.tableHeader}>{h}</th>)}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {V324.overseas.rows.map(r => (
                                                <tr key={r.to} style={styles.tableRow}>
                                                    {[r.to, r.country, r.when, r.items, r.purpose, r.period].map((c, i) => <td key={i} style={styles.tableCell}>{c}</td>)}
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                                <p style={styles.text}>{V324.overseas.refuseLine}</p>
                            </>
                        )}
                    </Section>

                    {/* 섹션 6 */}
                    <Section
                        id="section6"
                        title="6. 개인정보의 파기 절차 및 방법"
                        expanded={expandedSections.section6}
                        onToggle={() => toggleSection('section6')}
                    >
                        <div style={styles.subSection}>
                            <h4 style={styles.subTitle}>가. 파기 절차</h4>
                            <p style={styles.text}>
                                이용자가 회원가입 등을 위해 입력한 정보는 목적이 달성된 후
                                별도의 DB로 옮겨져(종이의 경우 별도의 서류함) 내부 방침 및
                                기타 관련 법령에 의한 정보보호 사유에 따라(보유 및 이용기간 참조)
                                일정 기간 저장된 후 파기됩니다.
                            </p>
                        </div>

                        <div style={styles.subSection}>
                            <h4 style={styles.subTitle}>나. 파기 방법</h4>
                            <ul style={styles.list}>
                                <li><strong>전자적 파일:</strong> 복구 및 재생되지 않도록 기술적 방법을 이용하여 완전하게 삭제</li>
                                <li><strong>종이 문서:</strong> 분쇄기로 분쇄하거나 소각</li>
                                <li><strong>스토어 정보:</strong> 판매자 탈퇴 또는 승인 취소 시 스토어 관련 정보 삭제</li>
                                <li><strong>중고물품 정보:</strong> 거래 완료 또는 삭제 요청 시 관련 정보 삭제</li>
                            </ul>
                        </div>

                        <div style={styles.infoBox}>
                            <p style={styles.infoText}>
                                💡 <strong>장기 미이용 계정 처리:</strong> 1년 이상 서비스를 이용하지 않은 회원의
                                개인정보는 「개인정보보호법」에 따라 다른 이용자의 개인정보와 분리하여
                                별도로 저장·관리됩니다. 파기 예정일 30일 전까지 이메일로 안내드립니다.
                            </p>
                        </div>
                    </Section>

                    {/* 섹션 7 */}
                    <Section
                        id="section7"
                        title="7. 정보주체의 권리·의무 및 행사 방법"
                        expanded={expandedSections.section7}
                        onToggle={() => toggleSection('section7')}
                    >
                        <p style={styles.text}>
                            정보주체는 회사에 대해 언제든지 다음 각 호의 개인정보 보호 관련 권리를 행사할 수 있습니다:
                        </p>

                        <div style={styles.rightsList}>
                            <div style={styles.rightItem}>
                                <div style={styles.rightNumber}>1</div>
                                <div style={styles.rightContent}>
                                    <h4 style={styles.rightTitle}>개인정보 열람 요구</h4>
                                    <p style={styles.rightDesc}>
                                        프로필 페이지에서 본인의 개인정보를 열람할 수 있습니다.
                                    </p>
                                </div>
                            </div>
                            <div style={styles.rightItem}>
                                <div style={styles.rightNumber}>2</div>
                                <div style={styles.rightContent}>
                                    <h4 style={styles.rightTitle}>개인정보 정정 요구</h4>
                                    <p style={styles.rightDesc}>
                                        오류가 있는 경우 프로필 페이지에서 직접 정정하거나 고객센터를 통해 요청할 수 있습니다.
                                    </p>
                                </div>
                            </div>
                            <div style={styles.rightItem}>
                                <div style={styles.rightNumber}>3</div>
                                <div style={styles.rightContent}>
                                    <h4 style={styles.rightTitle}>개인정보 삭제 요구</h4>
                                    <p style={styles.rightDesc}>
                                        {/* v3.2.3 — 이용 중지 중에도 삭제 요구 가능, 전화 창구 명시. 셀프 탈퇴 화면 없음 → 요청 접수·본인 확인·10일 처리로 정합 (절차 문서 2026-10-04 10절 정합 3) */}
                                        {'회원 탈퇴 또는 개인정보 삭제는 고객센터(010-2972-3733)·전자우편(dentcluster@gmail.com)으로 요구할 수 있으며, 회사는 가입 이메일로 본인임을 확인한 뒤 요구를 받은 날부터 10일 이내에 처리하고 결과를 알려 드립니다. 서비스 이용이 중지된 동안에도 같습니다.'}
                                    </p>
                                </div>
                            </div>
                            <div style={styles.rightItem}>
                                <div style={styles.rightNumber}>4</div>
                                <div style={styles.rightContent}>
                                    <h4 style={styles.rightTitle}>개인정보 처리정지 요구</h4>
                                    <p style={styles.rightDesc}>
                                        고객센터를 통해 개인정보 처리정지를 요구할 수 있습니다.
                                    </p>
                                </div>
                            </div>
                            <div style={styles.rightItem}>
                                <div style={styles.rightNumber}>5</div>
                                <div style={styles.rightContent}>
                                    <h4 style={styles.rightTitle}>스토어 공개/비공개 설정</h4>
                                    <p style={styles.rightDesc}>
                                        판매자는 스토어 설정에서 스토어 공개 여부를 직접 설정할 수 있습니다.
                                    </p>
                                </div>
                            </div>
                            {V324 && (
                                <div style={styles.rightItem}>
                                    <div style={styles.rightNumber}>6</div>
                                    <div style={styles.rightContent}>
                                        <h4 style={styles.rightTitle}>{V324.rightsItem.title}</h4>
                                        <p style={styles.rightDesc}>{V324.rightsItem.desc}</p>
                                    </div>
                                </div>
                            )}
                        </div>

                        <div style={styles.warningBox}>
                            <p style={styles.warningText}>
                                <strong>※ 권리 행사 제한 사유:</strong><br/>
                                법률에 특별한 규정이 있거나 법령상 의무를 준수하기 위해 불가피한 경우,
                                다른 사람의 생명·신체를 해할 우려가 있는 경우에는 권리 행사가 제한될 수 있습니다.
                            </p>
                        </div>

                        <p style={styles.text}>
                            <strong>권리 행사 방법:</strong> 개인정보보호법 시행규칙 별지 제8호 서식에 따라
                            서면, 전자우편, 모사전송(FAX), 전화(고객센터 010-2972-3733) 등을 통하여 하실 수 있으며,
                            회사는 이에 대해 지체 없이 조치하겠습니다.
                        </p>
                        {v335On && <p style={styles.text}>{V335_ACCESS_LINE}</p>}   {/* v3.3.5 법무 §2-5 열람 범위 */}
                    </Section>

                    {/* 섹션 8 */}
                    <Section
                        id="section8"
                        title="8. 개인정보의 안전성 확보 조치"
                        expanded={expandedSections.section8}
                        onToggle={() => toggleSection('section8')}
                    >
                        <p style={styles.text}>
                            회사는 개인정보의 안전성 확보를 위해 다음과 같은 조치를 취하고 있습니다:
                        </p>

                        <div style={styles.securityList}>
                            <div style={styles.securityItem}>
                                <div style={styles.securityIcon}>🔐</div>
                                <div style={styles.securityContent}>
                                    <h4 style={styles.securityTitle}>관리적 조치</h4>
                                    <ul style={styles.list}>
                                        <li>개인정보 취급 직원의 최소화 및 교육</li>
                                        <li>내부관리계획 수립 및 시행</li>
                                        <li>정기적인 자체 감사 실시</li>
                                    </ul>
                                </div>
                            </div>
                            <div style={styles.securityItem}>
                                <div style={styles.securityIcon}>🛡️</div>
                                <div style={styles.securityContent}>
                                    <h4 style={styles.securityTitle}>기술적 조치</h4>
                                    <ul style={styles.list}>
                                        <li>개인정보의 암호화 (비밀번호 등)</li>
                                        <li>해킹 등에 대비한 기술적 대책</li>
                                        <li>백신 프로그램 설치 및 주기적 갱신·점검</li>
                                        <li>접근통제 시스템 설치</li>
                                        <li>개인정보 접속기록 보관 및 위변조 방지</li>
                                        <li>Firebase Security Rules를 통한 데이터 접근 제어</li>
                                        <li>역할 기반 접근 제어 (관리자/판매자/일반회원 권한 분리)</li>
                                    </ul>
                                </div>
                            </div>
                            <div style={styles.securityItem}>
                                <div style={styles.securityIcon}>🔒</div>
                                <div style={styles.securityContent}>
                                    <h4 style={styles.securityTitle}>물리적 조치</h4>
                                    <ul style={styles.list}>
                                        <li>전산실, 자료보관실 등의 접근통제</li>
                                        <li>클라우드 서버 이용 시 보안인증 획득 업체 선정</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </Section>

                    {/* 섹션 9 */}
                    <Section
                        id="section9"
                        title="9. 개인정보 자동 수집 장치의 설치·운영 및 거부"
                        expanded={expandedSections.section9}
                        onToggle={() => toggleSection('section9')}
                    >
                        <div style={styles.subSection}>
                            <h4 style={styles.subTitle}>가. 쿠키(Cookie)란?</h4>
                            <p style={styles.text}>
                                회사는 이용자에게 개인화되고 맞춤화된 서비스를 제공하기 위해
                                이용자의 정보를 저장하고 수시로 불러오는 '쿠키(cookie)'를 사용합니다.
                                쿠키는 웹사이트를 운영하는데 이용되는 서버가 이용자의 브라우저에게 보내는
                                아주 작은 텍스트 파일로 이용자 컴퓨터의 하드디스크에 저장됩니다.
                            </p>
                        </div>

                        <div style={styles.subSection}>
                            <h4 style={styles.subTitle}>나. 쿠키의 사용 목적</h4>
                            <ul style={styles.list}>
                                <li>이용자의 접속 빈도나 방문 시간 등을 분석</li>
                                <li>이용자의 취향과 관심분야를 파악</li>
                                <li>각종 이벤트 참여 정도 및 방문 횟수 파악</li>
                                <li>로그인 상태 유지</li>
                            </ul>
                        </div>

                        <div style={styles.subSection}>
                            <h4 style={styles.subTitle}>다. 쿠키의 설치·운영 및 거부</h4>
                            <p style={styles.text}>
                                이용자는 쿠키 설치에 대한 선택권을 가지고 있습니다.
                                웹브라우저에서 옵션을 설정함으로써 모든 쿠키를 허용하거나,
                                쿠키가 저장될 때마다 확인을 거치거나, 아니면 모든 쿠키의 저장을 거부할 수도 있습니다.
                            </p>
                            <div style={styles.cookieBox}>
                                <p style={styles.cookieTitle}><strong>쿠키 설정 방법</strong></p>
                                <ul style={styles.list}>
                                    <li><strong>Chrome:</strong> 설정 &gt; 개인정보 및 보안 &gt; 쿠키 및 기타 사이트 데이터</li>
                                    <li><strong>Edge:</strong> 설정 &gt; 쿠키 및 사이트 권한 &gt; 쿠키 및 사이트 데이터 관리</li>
                                    <li><strong>Safari:</strong> 환경설정 &gt; 개인정보 &gt; 쿠키 및 웹 사이트 데이터</li>
                                </ul>
                                <p style={styles.warningText}>
                                    ※ 쿠키 저장을 거부할 경우 맞춤형 서비스 이용에 어려움이 발생할 수 있습니다.
                                </p>
                            </div>
                        </div>
                    </Section>

                    {/* 섹션 10 */}
                    <Section
                        id="section10"
                        title="10. 개인정보 보호책임자"
                        expanded={expandedSections.section10}
                        onToggle={() => toggleSection('section10')}
                    >
                        <p style={styles.text}>
                            회사는 개인정보 처리에 관한 업무를 총괄해서 책임지고,
                            개인정보 처리와 관련한 정보주체의 불만처리 및 피해구제 등을 위하여
                            아래와 같이 개인정보 보호책임자를 지정하고 있습니다.
                        </p>

                        <div style={styles.contactCard}>
                            <h4 style={styles.contactCardTitle}>개인정보 보호책임자</h4>
                            <div style={styles.contactGrid}>
                                <div style={styles.contactItem}>
                                    <span style={styles.contactLabel}>성명:</span>
                                    <span style={styles.contactValue}>김승우</span>
                                </div>
                                <div style={styles.contactItem}>
                                    <span style={styles.contactLabel}>담당 부서:</span>
                                    <span style={styles.contactValue}>DentalCluster 운영팀</span>
                                </div>
                                <div style={styles.contactItem}>
                                    <span style={styles.contactLabel}>이메일:</span>
                                    <span style={styles.contactValue}>dentcluster@gmail.com</span>
                                </div>
                                <div style={styles.contactItem}>
                                    <span style={styles.contactLabel}>전화:</span>
                                    <span style={styles.contactValue}>010-2972-3733</span>
                                </div>
                            </div>
                        </div>

                        <p style={styles.text}>
                            정보주체는 회사의 서비스를 이용하시면서 발생한 모든 개인정보보호 관련 문의,
                            불만처리, 피해구제 등에 관한 사항을 개인정보 보호책임자에게 문의하실 수 있습니다.
                            회사는 정보주체의 문의에 대해 지체 없이 답변 및 처리해드릴 것입니다.
                        </p>

                        <div style={styles.subSection}>
                            <h4 style={styles.subTitle}>기타 개인정보침해에 대한 신고나 상담이 필요하신 경우</h4>
                            <ul style={styles.list}>
                                <li>개인정보침해신고센터 (privacy.kisa.or.kr / 국번없이 118)</li>
                                <li>대검찰청 사이버범죄수사단 (www.spo.go.kr / 국번없이 1301)</li>
                                <li>경찰청 사이버안전국 (cyberbureau.police.go.kr / 국번없이 182)</li>
                            </ul>
                        </div>
                    </Section>

                    {/* 섹션 11 */}
                    <Section
                        id="section11"
                        title="11. 개인정보 처리방침의 변경"
                        expanded={expandedSections.section11}
                        onToggle={() => toggleSection('section11')}
                    >
                        <p style={styles.text}>
                            이 개인정보 처리방침은 시행일로부터 적용되며,
                            법령 및 방침에 따른 변경내용의 추가, 삭제 및 정정이 있는 경우에는
                            변경사항의 시행 <strong>7일 전부터</strong> 공지사항을 통하여 고지할 것입니다.
                            다만, 개인정보의 수집 및 활용, 제3자 제공 등과 같이 이용자 권리의
                            중요한 변경이 있을 경우에는 최소 <strong>30일 전에</strong> 고지합니다.
                        </p>

                        <div style={styles.versionBox}>
                            <h4 style={styles.versionTitle}>개인정보 처리방침 버전 정보</h4>
                            <ul style={styles.versionList}>
                                <li><strong>공고일자:</strong> 2026년 4월 9일</li>
                                <li><strong>시행일자:</strong> 2026년 4월 9일</li>
                                <li><strong>{'v3.2.1 공고·시행일자:'}</strong> {PRIVACY_V321_DATE}</li>
                                <li><strong>{'v3.2.2 공고일자:'}</strong> {`${PRIVACY_V322_NOTICE_DATE} / 시행일자: ${PRIVACY_V322_DATE}`}</li>
                                <li><strong>{'v3.2.3 공고일자:'}</strong> {`${PRIVACY_V323_NOTICE_DATE} / 시행일자: ${PRIVACY_V323_DATE}`}</li>
                                <li><strong>{'v3.2.7 공고·시행일자:'}</strong> {`${PRIVACY_V327_DATE} (v3.2.5·v3.2.6보다 먼저 시행)`}</li>
                                <li><strong>{'v3.2.8 공고일자:'}</strong> {`${PRIVACY_V328_NOTICE_DATE} / 시행일자: ${PRIVACY_V328_DATE} (v3.2.5·v3.2.6보다 먼저 시행)`}</li>
                                {(isPrivacyJigNoticePeriod || isPrivacyJigOn) && <li><strong>{'v3.2.9 공고일자:'}</strong> {`${PRIVACY_JIG_NOTICE_DATE} / 시행일자: ${PRIVACY_JIG_DATE}`}</li>}
                                {(isPrivacyDesignNoticePeriod || isPrivacyDesignOn) && <li><strong>{'v3.3.0 공고일자:'}</strong> {`${PRIVACY_DESIGN_NOTICE_DATE} / 시행일자: ${PRIVACY_DESIGN_DATE}`}</li>}
                                {V324 && <li><strong>{`${V324.version} 공고일자:`}</strong> {`${V324.noticeDate} / 시행일자: ${V324.effectiveDate}`}</li>}
                                {v335Announced && <li><strong>{`${PRIVACY_V335_VERSION} 공고일자:`}</strong> {`${PRIVACY_V335_NOTICE_DATE} / 시행일자: ${PRIVACY_V335_DATE}`}</li>}
                                {/* v3.2.8(10-23 시행)이 현재 판(시행 전에는 v3.2.7 + 「시행 예정」 v3.2.8). V324(v3.2.5)는 시행일 전 「시행 예정」 줄, 시행 뒤엔 「v3.2.8 내용 포함」 */}
                                {V324 && Date.now() >= V324_EFFECTIVE_MS ? (
                                    <li><strong>버전:</strong> {`${V324.version} (${V324.effectiveDate}: ${V324.versionLine}) — v3.2.8 내용 포함`}</li>
                                ) : (
                                    <>
                                        {v328On
                                            ? <li><strong>버전:</strong> {`v3.2.8 (${PRIVACY_V328_DATE}: ${V328_VERSION_DESC})`}</li>
                                            : <>
                                                <li><strong>버전:</strong> {`v3.2.7 (${PRIVACY_V327_DATE}: 기공소 간 외주 기록 수탁 처리 추가)`}</li>
                                                <li><strong>시행 예정:</strong> {`v3.2.8(${PRIVACY_V328_DATE}: ${V328_VERSION_DESC})`}</li>
                                              </>}
                                        {V324 && <li><strong>시행 예정:</strong> {`${V324.version}(${V324.effectiveDate}: ${V324.versionLine})`}</li>}
                                    </>
                                )}
                                {/* v3.2.9 지그 — 공고 후 '시행 예정', 시행(2026-10-28) 뒤 '버전' */}
                                {(isPrivacyJigNoticePeriod || isPrivacyJigOn) && (isPrivacyJigOn
                                    ? <li><strong>버전:</strong> {`${PRIVACY_JIG_VERSION} (${PRIVACY_JIG_DATE}: ${PRIVACY_JIG_VERSION_DESC})`}</li>
                                    : <li><strong>시행 예정:</strong> {`${PRIVACY_JIG_VERSION}(${PRIVACY_JIG_DATE}: ${PRIVACY_JIG_VERSION_DESC})`}</li>)}
                                {/* [법적보안 2026-10-24] v3.3.3 지그·모델 7일 — 지그 절이 켜진 동안만 표시 */}
                                {isPrivacyJigOn && <li><strong>버전:</strong> {`${PRIVACY_JIG7_VERSION} (${PRIVACY_JIG7_DATE}: ${PRIVACY_JIG7_VERSION_DESC})`}</li>}
                                {/* [법적보안 2026-10-24] v3.3.4 완성 디자인 14일 보관 정정 — 완성 디자인 절이 켜진 동안만 표시 */}
                                {isPrivacyDesignOn && <li><strong>버전:</strong> {`${PRIVACY_DESIGN14_VERSION} (${PRIVACY_DESIGN14_DATE}: ${PRIVACY_DESIGN14_VERSION_DESC})`}</li>}
                                {/* v3.3.0 완성 디자인 — 공고 후 '시행 예정', 시행(당일 2026-10-21) 뒤 '버전' */}
                                {(isPrivacyDesignNoticePeriod || isPrivacyDesignOn) && (isPrivacyDesignOn
                                    ? <li><strong>버전:</strong> {`${PRIVACY_DESIGN_VERSION} (${PRIVACY_DESIGN_DATE}: ${PRIVACY_DESIGN_VERSION_DESC})`}</li>
                                    : <li><strong>시행 예정:</strong> {`${PRIVACY_DESIGN_VERSION}(${PRIVACY_DESIGN_DATE}: ${PRIVACY_DESIGN_VERSION_DESC})`}</li>)}
                                {/* v3.3.5 (S5) — 공고 후 '시행 예정', 시행(2026-11-03) 뒤 '버전' */}
                                {v335Announced && (v335On
                                    ? <li><strong>버전:</strong> {`${PRIVACY_V335_VERSION} (${PRIVACY_V335_DATE}: ${V335_VERSION_DESC})`}</li>
                                    : <li><strong>시행 예정:</strong> {`${PRIVACY_V335_VERSION}(${PRIVACY_V335_DATE}: ${V335_VERSION_DESC})`}</li>)}
                            </ul>
                            <div style={styles.versionHistory}>
                                <p style={styles.versionHistoryTitle}>변경 이력:</p>
                                <ul style={styles.list}>
                                    <li>v1.0 (2025.11.23): 최초 제정</li>
                                    <li>v2.0 (2025.12.05): 중고물품 거래, 마케터 서비스, 스토어 설정 관련 내용 추가</li>
                                    <li>v3.0 (2026.04.09): 환자 리뷰 시스템·방문자 통계·홍보 페이지 등록 항목 추가, 위탁업체에 팝빌(전자세금계산서)·카카오맵·ipapi.co·국세청 홈택스 추가, 광고 대행 위탁(네이버·메타) 명시</li>
                                    <li>v3.1 (2026.08.02): 환자정보 수탁자 지위·전송 파일 삭제 주기 신설</li>
                                    <li>v3.2 (2026.09.04): 모바일 앱 푸시 알림 토큰·알림 열람 기록 수집 항목 추가</li>
                                    <li>{`v3.2.1 (${PRIVACY_V321_DATE}): 치과 데스크 접수 기록의 수탁 처리(항목·목적·보유 기간 2년·재위탁·권리 행사 창구) 절 추가, 12. 아동의 개인정보 보호에 위탁 처리 예외 추가`}</li>
                                    <li>{`v3.2.2 (${PRIVACY_V322_DATE}): 치과 데스크 직접 입력(이름·오신 이유, 당일 삭제) 수탁 처리 항목 추가`}</li>
                                    <li>{`v3.2.3 (${PRIVACY_V323_DATE}): 개인정보 처리 위탁에 토스페이먼츠(구독 정기결제·결제 카드 등록) 추가, 개인정보 보호책임자 전화번호 변경, 개인정보 삭제 요구 창구에 고객센터 전화·전자우편 추가(서비스 이용 중지 중에도 동일), 권리 행사 방법에 전화 추가`}</li>
                                    <li>{`v3.2.7 (${PRIVACY_V327_DATE}, v3.2.5·v3.2.6보다 먼저 시행): 5. 개인정보 처리의 위탁에 기공소 간 외주(CAD 디자인·제작) 기록의 수탁 처리 절 추가(처리 항목·목적·재위탁 동의 확인·받는 곳 열람 기간·보유 기간 2년(위탁 약정)·환자 이름 먼저 삭제·파일 삭제·CNC 케이스 번호), 3. 보유 기간 표의 치과기공물 의뢰서 줄을 위탁 절 안내로 정리`}</li>
                                    <li>{`v3.2.8 (${PRIVACY_V328_DATE} 시행, ${PRIVACY_V328_NOTICE_DATE} 공고, v3.2.5·v3.2.6보다 먼저 시행): ${V328_HISTORY_BODY}`}</li>
                                    {V324 && <li>{`${V324.version} (${V324.effectiveDate}): ${V324.historyBody}`}</li>}
                                    {isPrivacyJigOn && <li>{`${PRIVACY_JIG_VERSION} (${PRIVACY_JIG_DATE}): 5. 개인정보 처리의 위탁에 치과 지그 결과의 처리 절 추가(처리 항목·목적·보유 기간 2주(위탁 약정)·본인 기공소만 열람·암호화·접속기록·Firebase 재위탁·진료기록 아님), "일시 저장 후 삭제" 원칙은 전달용 파일 한정이고 지그 결과는 예외임을 명시, 2. 수집 항목·3. 보유 기간 교차 참조 추가`}</li>}
                                    {isPrivacyDesignOn && <li>{`${PRIVACY_DESIGN_VERSION} (${PRIVACY_DESIGN_DATE}): 5. 개인정보 처리의 위탁에 완성 디자인 산출물(재택·외주·지그)의 처리 절 추가(처리 항목·목적·보유 기간(내려받으면 그 뒤 삭제, 내려받지 않아도 생성일부터 2주, 위탁 약정 — v3.3.4에서 생성일부터 14일 보관으로 정정)·본인 기공소만 열람·암호화·접속기록·자동 보관+설정 끄기(opt-out)·수탁자 책임·Firebase 재위탁·진료기록 아님), "일시 저장 후 삭제" 원칙은 전달용 파일 한정이고 완성 산출물은 예외임을 명시, 2. 수집 항목·3. 보유 기간 교차 참조 추가`}</li>}
                                    {/* 2026-10-23 거래명세서 1단계(미수 원장·청구 마감일) — 계약 §2 법무 고정 문구. 판 번호·공고/시행일은 법적보안 확정 대상 */}
                                    <li>{'v3.3.1 (2026.10.23): 2. 수집 항목의 서비스 이용 중 생성 정보에 거래처별 입금 기록·청구 마감일(기공소 회원이 직접 입력) 추가'}</li>
                                    {/* 2026-10-24 거래명세서 2단계(공유 링크·계산서 원클릭) — 계약 §2. 판 번호·공고/시행일은 법적보안 확정 대상 */}
                                    <li>{'v3.3.2 (2026.10.24): 2. 수집 항목에 공유 링크 확인자 이름·수정 요청 내용 추가, 3. 보유 기간에 공유 링크(생성일부터 60일 열람, 만료 후 30일 이내 삭제) 추가, 4. 제3자 제공(법령)에 전자(세금)계산서 기재 정보의 국세청 전송 추가, 5. 위탁 표의 팝빌 업무를 전자세금계산서·전자계산서 발행 대행 및 국세청 전송, 발행 안내 메일 발송으로 정리'}</li>
                                    {/* v3.3.5 (S5, 2026-10-27 공고 · 2026-11-03 시행) — 시행 뒤 표시. 문안 config/privacyV335.js */}
                                    {v335On && <li>{`${PRIVACY_V335_VERSION} (2026.11.03, ${PRIVACY_V335_NOTICE_DATE} 공고): ${V335_HISTORY_BODY}`}</li>}
                                    {/* [법적보안 2026-10-24] 지그·모델 7일 — 판 번호·공고/시행일은 대표 확인 대상(초안) */}
                                    {isPrivacyJigOn && <li>{`${PRIVACY_JIG7_VERSION} (2026.10.24): 5. 개인정보 처리의 위탁 [치과 지그 결과의 처리] 절 개정 — 보유 기간을 생성일부터 2주(14일)에서 7일로 단축, 처리 항목에 3D 모델 결과 파일과 결과 사진(지그·모델·결합 PNG, 모델 바닥 음각 환자 이름이 보일 수 있음) 추가, 2. 수집 항목·3. 보유 기간 교차 참조와 [완성 디자인 산출물의 처리] 절의 지그 관련 문구를 같이 정리`}</li>}
                                    {/* [법적보안 2026-10-24] v3.3.4 완성 디자인 14일 보관 정정(대표 10-24 밤) — 초안, 변호사 최종 검토 전 */}
                                    {isPrivacyDesignOn && <li>{`${PRIVACY_DESIGN14_VERSION} (2026.10.24): 5. 개인정보 처리의 위탁 [완성 디자인 산출물의 처리] 절 개정 — 보유 기간을 「내려받으면 그 뒤 삭제, 늦어도 생성일부터 2주」에서 「생성일부터 14일 보관, 보관 기간 안에는 여러 번 내려받기 가능, 14일이 지나면 자동 삭제」로 정리하고 내려받기 기록(누가·언제)을 명시, 3. 보유 기간 교차 참조 문구와 v3.3.0 공고 상자 문안을 같이 정정`}</li>}
                                </ul>
                            </div>
                        </div>
                    </Section>

                    {/* 섹션 12 */}
                    <Section
                        id="section12"
                        title="12. 아동의 개인정보 보호"
                        expanded={expandedSections.section12}
                        onToggle={() => toggleSection('section12')}
                    >
                        {/* v3.2.1 — 정본 §7-4-2 교체문(위탁 처리 예외) */}
                        <p style={styles.text}>
                            {'회사는 회원 가입 등 회사가 직접 개인정보처리자로서 처리하는 경우 만 14세 미만 아동의 개인정보를 수집하지 않습니다. 이런 경우 만 14세 미만 아동의 개인정보가 수집된 사실을 확인하면 즉시 삭제하는 등 필요한 조치를 취합니다.'}
                        </p>
                        <p style={styles.text}>
                            {'다만 의료기관(치과)의 위탁을 받아 처리하는 데스크 접수 기록에는 만 14세 미만 환자의 정보가 포함될 수 있습니다. 이 경우 법정대리인(부모 또는 후견인)이 직접 작성하고 동의하며, 처리 항목·목적·보유 기간은 「5. 개인정보 처리의 위탁」의 [치과 데스크 접수 기록의 처리]에 따릅니다.'}
                        </p>
                        <div style={styles.infoBox}>
                            <p style={styles.infoText}>
                                {'💡 만 14세 미만 아동의 개인정보 처리에 대한 동의와 열람·정정·삭제·처리정지 요구는 법정대리인(부모 또는 후견인)이 할 수 있습니다. 데스크 접수 기록에 관한 요구는 해당 의료기관에 하시면 됩니다.'}
                            </p>
                        </div>
                        {V324 && <p style={styles.text}>{V324.childLine}</p>}
                    </Section>
                </div>

                {/* 하단 버튼 */}
                <div style={styles.footer}>
                    <p style={styles.footerNote}>
                        본 개인정보 처리방침에 동의하시면 서비스 이용이 가능합니다.
                    </p>
                    <button onClick={onClose} style={styles.confirmButton}>
                        확인했습니다
                    </button>
                </div>
            </div>
        </div>
    );
}

// 접을 수 있는 섹션 컴포넌트
function Section({ id, title, children, expanded, onToggle }) {
    return (
        <div style={styles.section}>
            <button
                onClick={onToggle}
                style={styles.sectionHeader}
            >
                <h3 style={styles.sectionTitle}>{title}</h3>
                {expanded ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
            </button>
            {expanded && (
                <div style={styles.sectionContent}>
                    {children}
                </div>
            )}
        </div>
    );
}

const styles = {
    // v3.2.8 개정 공고 상자 (TermsOfService noticeBox 모양)
    v328Box: { background: '#F5F7FF', border: '1px solid #DDE3F5', borderRadius: 10, padding: '12px 14px', margin: '0 0 20px', fontSize: 13, color: '#3B4468', lineHeight: 1.7 },
    v328Toggle: { background: 'none', border: 'none', padding: 0, marginTop: 4, color: '#4F52C7', fontWeight: 700, fontSize: 13, cursor: 'pointer' },
    overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9999,
        padding: '20px',
    },
    modal: {
        backgroundColor: '#ffffff',
        borderRadius: '16px',
        width: '100%',
        maxWidth: '900px',
        maxHeight: '90vh',
        display: 'flex',
        flexDirection: 'column',
        boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
    },
    header: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '24px 32px',
        borderBottom: '2px solid #e5e7eb',
        backgroundColor: '#f8fafc',
    },
    headerTitle: {
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
    },
    title: {
        margin: 0,
        fontSize: '24px',
        fontWeight: '700',
        color: '#1e293b',
    },
    closeButton: {
        background: 'none',
        border: 'none',
        color: '#64748b',
        cursor: 'pointer',
        padding: '8px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '8px',
        transition: 'all 0.2s',
    },
    content: {
        padding: '32px',
        overflowY: 'auto',
        flex: 1,
    },
    intro: {
        marginBottom: '32px',
        padding: '20px',
        backgroundColor: '#f1f5f9',
        borderLeft: '4px solid #6366f1',
        borderRadius: '8px',
    },
    introText: {
        margin: '0 0 12px 0',
        fontSize: '14px',
        color: '#475569',
        lineHeight: '1.7',
    },
    tocBox: {
        marginBottom: '32px',
        padding: '24px',
        backgroundColor: '#ffffff',
        border: '2px solid #e2e8f0',
        borderRadius: '12px',
    },
    tocTitle: {
        margin: '0 0 16px 0',
        fontSize: '18px',
        fontWeight: '600',
        color: '#1e293b',
    },
    tocList: {
        margin: 0,
        paddingLeft: '24px',
        fontSize: '14px',
        color: '#475569',
        lineHeight: '2',
    },
    section: {
        marginBottom: '16px',
        border: '1px solid #e2e8f0',
        borderRadius: '12px',
        overflow: 'hidden',
    },
    sectionHeader: {
        width: '100%',
        padding: '16px 20px',
        backgroundColor: '#f8fafc',
        border: 'none',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        cursor: 'pointer',
        transition: 'all 0.2s',
    },
    sectionTitle: {
        margin: 0,
        fontSize: '16px',
        fontWeight: '600',
        color: '#1e293b',
        textAlign: 'left',
    },
    sectionContent: {
        padding: '24px',
        backgroundColor: '#ffffff',
    },
    subSection: {
        marginBottom: '24px',
    },
    subTitle: {
        margin: '0 0 12px 0',
        fontSize: '15px',
        fontWeight: '600',
        color: '#334155',
    },
    text: {
        margin: '0 0 12px 0',
        fontSize: '14px',
        color: '#475569',
        lineHeight: '1.7',
    },
    list: {
        margin: '8px 0',
        paddingLeft: '24px',
        fontSize: '14px',
        color: '#475569',
        lineHeight: '1.8',
    },
    tableBox: {
        overflowX: 'auto',
        marginBottom: '16px',
    },
    table: {
        width: '100%',
        borderCollapse: 'collapse',
        fontSize: '14px',
    },
    tableHeaderRow: {
        backgroundColor: '#f1f5f9',
    },
    tableHeader: {
        padding: '12px',
        textAlign: 'left',
        fontWeight: '600',
        color: '#1e293b',
        borderBottom: '2px solid #e2e8f0',
    },
    tableRow: {
        borderBottom: '1px solid #e2e8f0',
    },
    tableRowHighlight: {
        borderBottom: '1px solid #e2e8f0',
        backgroundColor: '#fef3c7',
    },
    tableCell: {
        padding: '12px',
        color: '#475569',
        lineHeight: '1.6',
    },
    tableCellHighlight: {
        padding: '12px',
        color: '#92400e',
        lineHeight: '1.6',
    },
    warningBox: {
        padding: '16px',
        backgroundColor: '#fef2f2',
        border: '1px solid #fecaca',
        borderRadius: '8px',
        marginTop: '16px',
    },
    warningText: {
        margin: 0,
        fontSize: '13px',
        color: '#dc2626',
        lineHeight: '1.6',
    },
    infoBox: {
        padding: '16px',
        backgroundColor: '#eff6ff',
        border: '1px solid #bfdbfe',
        borderRadius: '8px',
        marginTop: '16px',
    },
    infoText: {
        margin: 0,
        fontSize: '13px',
        color: '#1e40af',
        lineHeight: '1.6',
    },
    rightsList: {
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
        marginTop: '16px',
    },
    rightItem: {
        display: 'flex',
        gap: '16px',
        padding: '16px',
        backgroundColor: '#f8fafc',
        borderRadius: '8px',
        border: '1px solid #e2e8f0',
    },
    rightNumber: {
        width: '32px',
        height: '32px',
        borderRadius: '50%',
        backgroundColor: '#6366f1',
        color: 'white',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontWeight: '600',
        fontSize: '16px',
        flexShrink: 0,
    },
    rightContent: {
        flex: 1,
    },
    rightTitle: {
        margin: '0 0 8px 0',
        fontSize: '15px',
        fontWeight: '600',
        color: '#1e293b',
    },
    rightDesc: {
        margin: 0,
        fontSize: '13px',
        color: '#64748b',
        lineHeight: '1.6',
    },
    securityList: {
        display: 'flex',
        flexDirection: 'column',
        gap: '20px',
        marginTop: '16px',
    },
    securityItem: {
        display: 'flex',
        gap: '16px',
    },
    securityIcon: {
        fontSize: '32px',
        flexShrink: 0,
    },
    securityContent: {
        flex: 1,
    },
    securityTitle: {
        margin: '0 0 12px 0',
        fontSize: '15px',
        fontWeight: '600',
        color: '#1e293b',
    },
    cookieBox: {
        padding: '16px',
        backgroundColor: '#f8fafc',
        border: '1px solid #e2e8f0',
        borderRadius: '8px',
        marginTop: '12px',
    },
    cookieTitle: {
        margin: '0 0 12px 0',
        fontSize: '14px',
        color: '#1e293b',
    },
    contactCard: {
        padding: '24px',
        backgroundColor: '#f8fafc',
        border: '2px solid #e2e8f0',
        borderRadius: '12px',
        marginTop: '16px',
        marginBottom: '24px',
    },
    contactCardTitle: {
        margin: '0 0 16px 0',
        fontSize: '16px',
        fontWeight: '600',
        color: '#1e293b',
    },
    contactGrid: {
        display: 'grid',
        gridTemplateColumns: '1fr',
        gap: '12px',
    },
    contactItem: {
        display: 'flex',
        gap: '12px',
    },
    contactLabel: {
        fontWeight: '600',
        color: '#64748b',
        fontSize: '14px',
        minWidth: '100px',
    },
    contactValue: {
        color: '#1e293b',
        fontSize: '14px',
    },
    versionBox: {
        padding: '20px',
        backgroundColor: '#f1f5f9',
        borderRadius: '8px',
        marginTop: '16px',
    },
    versionTitle: {
        margin: '0 0 12px 0',
        fontSize: '15px',
        fontWeight: '600',
        color: '#1e293b',
    },
    versionList: {
        margin: 0,
        paddingLeft: '20px',
        fontSize: '14px',
        color: '#475569',
        lineHeight: '1.8',
        listStyle: 'none',
    },
    versionHistory: {
        marginTop: '16px',
        paddingTop: '16px',
        borderTop: '1px solid #e2e8f0',
    },
    versionHistoryTitle: {
        margin: '0 0 8px 0',
        fontSize: '14px',
        fontWeight: '600',
        color: '#64748b',
    },
    footer: {
        padding: '24px 32px',
        borderTop: '2px solid #e5e7eb',
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
        alignItems: 'center',
        backgroundColor: '#f8fafc',
    },
    footerNote: {
        margin: 0,
        fontSize: '13px',
        color: '#64748b',
        textAlign: 'center',
    },
    confirmButton: {
        padding: '12px 48px',
        backgroundColor: '#6366f1',
        color: '#ffffff',
        border: 'none',
        borderRadius: '8px',
        fontSize: '15px',
        fontWeight: '600',
        cursor: 'pointer',
        transition: 'all 0.2s',
    },
};

export default PrivacyPolicy;